<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 562 133"
    >
        <defs>
            <path
                id="aA"
                d="M.922.34C.912.441.891.54.891.643c0 .104.021.202.031.303.009-.101.03-.199.03-.303C.952.54.931.441.922.34"
            />
            <path
                id="aB"
                d="M1.464.915a3.302 3.302 0 0 0-.084.728c0 .251.031.494.084.729.052-.235.085-.478.085-.729a3.35 3.35 0 0 0-.085-.728"
            />
            <path
                id="aC"
                d="M.988 2.494c.072-.274.123-.555.123-.851 0-.295-.051-.577-.123-.85-.07.273-.12.555-.12.85 0 .296.05.577.12.851"
            />
            <path
                id="aD"
                d="M.808.73c-.01.105-.031.206-.031.312 0 .107.021.208.031.312.01-.104.031-.205.031-.312C.839.936.818.835.808.73"
            />
            <path
                id="aE"
                d="M1.341.192a3.42 3.42 0 0 0-.119.85c0 .296.049.578.119.851a3.32 3.32 0 0 0 .123-.851c0-.295-.051-.577-.123-.85"
            />
            <path
                id="aF"
                d="M.551.503c.202.036.407.062.619.062.212 0 .417-.026.619-.062A3.24 3.24 0 0 0 1.17.441a3.24 3.24 0 0 0-.619.062"
            />
            <path
                id="aG"
                d="M.856.892a3.483 3.483 0 0 0-.209 1.15c0 .406.083.789.209 1.152.13-.362.213-.745.213-1.152 0-.405-.083-.789-.213-1.15"
            />
            <path
                id="aH"
                d="M2.545.513a3.181 3.181 0 0 0-.85-.126c-.296 0-.577.051-.85.126.274.067.556.112.85.112.294 0 .576-.045.85-.112"
            />
            <path
                id="aI"
                d="M1.399.64c-.184.43-.286.904-.286 1.402 0 .499.102.973.286 1.404a3.505 3.505 0 0 0 0-2.806"
            />
            <path
                id="aJ"
                d="M.115.517C.466.628.832.705 1.22.705S1.974.628 2.325.517A3.292 3.292 0 0 0 1.22.314 3.3 3.3 0 0 0 .115.517"
            />
            <path
                id="aK"
                d="M.912 3.591c.227-.47.366-.991.366-1.549 0-.557-.139-1.078-.366-1.548a3.636 3.636 0 0 0-.354 1.548c0 .556.133 1.077.354 1.549"
            />
            <path
                id="aL"
                d="M.512.519c.388.137.799.226 1.233.226.435 0 .846-.089 1.233-.226A3.331 3.331 0 0 0 1.745.278c-.436 0-.85.089-1.233.241"
            />
            <path
                id="aM"
                d="M1.828.578C1.574.477 1.323.372 1.067.274c.032.518.169 1.003.393 1.442A3.61 3.61 0 0 0 1.828.578"
            />
            <path id="aN" d="M1.883.906a3.299 3.299 0 0 0-1.325 0 3.355 3.355 0 0 0 1.325 0" />
            <path
                id="aO"
                d="M.922.865c-.01.101-.031.199-.031.303 0 .104.021.202.031.303.009-.101.03-.199.03-.303 0-.104-.021-.202-.03-.303"
            />
            <path
                id="aP"
                d="M2.534.906a3.312 3.312 0 0 0-.789-.103c-.273 0-.535.041-.789.103.254.061.516.103.789.103s.535-.042.789-.103"
            />
            <path
                id="aQ"
                d="M1.464.439a3.311 3.311 0 0 0-.084.729c0 .251.031.494.084.729.052-.235.085-.478.085-.729S1.516.675 1.464.439"
            />
            <path
                id="aR"
                d="M.359.906c.292.081.593.139.911.139.318 0 .619-.058.911-.139A3.347 3.347 0 0 0 1.27.767C.952.767.651.824.359.906"
            />
            <path
                id="aS"
                d="M.988 2.018c.072-.273.123-.554.123-.85 0-.296-.051-.577-.123-.85-.07.273-.12.555-.12.85 0 .296.05.577.12.85"
            />
            <path
                id="aT"
                d="M1.523 1.467c-.101-.01-.199-.031-.303-.031-.104 0-.202.021-.303.031.101.009.199.03.303.03.104 0 .202-.021.303-.03"
            />
            <path
                id="aU"
                d="M.016 1.45c.236.052.478.084.729.084s.493-.033.729-.084a3.312 3.312 0 0 0-.729-.086c-.251 0-.494.033-.729.086"
            />
            <path
                id="aV"
                d="M1.446.39c-.009.102-.03.199-.03.303 0 .104.021.202.03.303.01-.101.031-.199.031-.303 0-.104-.021-.201-.031-.303"
            />
            <path
                id="aW"
                d="M2.12 1.45a3.311 3.311 0 0 0-.85-.122c-.296 0-.577.05-.85.122.273.07.555.12.85.12a3.4 3.4 0 0 0 .85-.12"
            />
            <path
                id="aX"
                d="M.988.964a3.436 3.436 0 0 0-.084.729c0 .251.033.494.084.729.053-.235.086-.478.086-.729S1.041 1.2.988.964"
            />
            <path
                id="aY"
                d="M1.048.992C.947.982.849.961.745.961.641.961.543.982.442.992c.101.009.199.03.303.03.104 0 .202-.021.303-.03"
            />
            <path
                id="aZ"
                d="M.541.975c.235.052.478.084.729.084s.494-.032.729-.084A3.305 3.305 0 0 0 1.27.889c-.251 0-.494.033-.729.086"
            />
            <path
                id="ba"
                d="M.971.915c-.009.102-.03.199-.03.303 0 .104.021.202.03.303.01-.101.031-.199.031-.303 0-.104-.021-.201-.031-.303"
            />
            <path
                id="bb"
                d="M1.573.517C1.472.507 1.374.486 1.27.486c-.104 0-.202.021-.303.031.101.009.199.03.303.03.104 0 .202-.021.303-.03"
            />
            <path
                id="bc"
                d="M.497 2.194c.103-.325.175-.666.175-1.026S.6.468.497.142C.403.47.337.81.337 1.168s.066.698.16 1.026"
            />
            <path
                id="bd"
                d="M.499 2.592c.08-.288.136-.585.136-.899 0-.313-.056-.611-.136-.898a3.65 3.65 0 0 0-.123.898c0 .312.05.61.123.899"
            />
            <path
                id="be"
                d="M.322 1.453a3.7 3.7 0 0 0 1.756.457c.639 0 1.23-.175 1.756-.457A3.66 3.66 0 0 0 2.078.991c-.639 0-1.231.177-1.756.462"
            />
            <path
                id="bf"
                d="M.501.447a3.636 3.636 0 0 0-.085.771c0 .265.031.522.085.771.059-.248.098-.504.098-.771A3.33 3.33 0 0 0 .501.447"
            />
            <path
                id="bg"
                d="M3.751.979A3.618 3.618 0 0 0 2.078.556C1.472.556.909.718.405.979a3.672 3.672 0 0 0 1.673.416c.606 0 1.169-.159 1.673-.416"
            />
            <path
                id="bh"
                d="M.511.588C.509.641.496.69.496.743c0 .053.013.103.015.155C.514.846.527.796.527.743.527.69.514.641.511.588"
            />
            <path
                id="bi"
                d="M.529.526c.473.221.994.354 1.549.354.556 0 1.077-.133 1.549-.354A3.552 3.552 0 0 0 2.078.161C1.521.161 1 .299.529.526"
            />
            <path id="bj" d="M3.481 1.039a3.51 3.51 0 0 0-2.806 0 3.565 3.565 0 0 0 2.806 0" />
            <path
                id="bk"
                d="M3.229.582A3.406 3.406 0 0 0 2.078.37c-.406 0-.79.083-1.151.212.363.126.746.209 1.151.209.406 0 .788-.083 1.151-.209"
            />
            <path
                id="bl"
                d="M.228 1.097c.273.07.555.119.85.119.295 0 .577-.049.85-.119a3.311 3.311 0 0 0-.85-.122c-.296 0-.577.05-.85.122"
            />
            <path
                id="bm"
                d="M.766.63c.104.01.205.032.312.032.107 0 .208-.022.312-.032-.104-.009-.205-.031-.312-.031C.971.599.87.621.766.63"
            />
            <path
                id="bn"
                d="M.573 2.864c.124-.37.207-.759.207-1.171C.78 1.281.697.892.573.522.45.893.367 1.282.367 1.693c0 .411.083.8.206 1.171"
            />
            <path
                id="bo"
                d="M.499 3.495c.149-.399.241-.826.241-1.277 0-.45-.092-.878-.241-1.276a3.815 3.815 0 0 0-.236 1.276c0 .449.094.874.236 1.277"
            />
            <path
                id="bp"
                d="M2.336 1.552c.078 0 .15-.018.227-.022-.175-.418-.358-.83-.545-1.24a4.116 4.116 0 0 0-1.89.609 4.029 4.029 0 0 0 2.208.653"
            />
            <path
                id="bq"
                d="M.956 2.467c.124.058.245.12.362.191.08-.045.167-.08.244-.129A43.625 43.625 0 0 0 .918.232a3.822 3.822 0 0 0-.166 1.057c0 .414.084.804.204 1.178"
            />
            <path
                id="br"
                d="M.623.369C.61.494.584.615.584.743s.026.25.039.374C.636.993.661.871.661.743S.636.494.623.369"
            />
            <path
                id="bs"
                d="M4.06.793C4.016.689 3.991.576 3.956.467a3.795 3.795 0 0 0-1.62-.371C1.607.096.931.307.355.658c.589.321 1.258.52 1.981.52A4.13 4.13 0 0 0 4.06.793"
            />
            <path
                id="bt"
                d="M1.06.793c.2.472.49.895.85 1.255-.084-.39-.172-.777-.266-1.161a3.672 3.672 0 0 0-.326-.229c-.085.046-.169.094-.258.135"
            />
            <path
                id="bu"
                d="M1.318.658A3.785 3.785 0 0 0 .956.467c.035.109.06.222.104.326.089-.041.173-.089.258-.135"
            />
            <path
                id="bv"
                d="M1.469.366c-.071.291-.119.59-.119.902 0 .312.048.612.119.903.078-.29.132-.589.132-.903 0-.314-.054-.613-.132-.902"
            />
            <path
                id="bw"
                d="M.446.876a3.783 3.783 0 0 0 1.89.514A3.79 3.79 0 0 0 4.227.876 4.034 4.034 0 0 0 2.336.393a4.03 4.03 0 0 0-1.89.483"
            />
            <path
                id="bx"
                d="M1.482.601c-.003.065-.02.126-.02.192s.017.127.02.192c.004-.065.02-.126.02-.192s-.016-.127-.02-.192"
            />
            <path
                id="by"
                d="M.318.593c.594.341 1.278.55 2.018.55.74 0 1.424-.209 2.018-.55A3.92 3.92 0 0 0 2.336.028 3.92 3.92 0 0 0 .318.593"
            />
            <path
                id="bz"
                d="M4.143 1.105A3.83 3.83 0 0 0 2.336.64c-.658 0-1.267.178-1.807.465a3.92 3.92 0 0 0 1.807.454 3.92 3.92 0 0 0 1.807-.454"
            />
            <path
                id="bA"
                d="M3.549.786c.03-.09.062-.179.091-.269A3.752 3.752 0 0 0 2.336.274c-.574 0-1.111.14-1.595.369a3.839 3.839 0 0 0 1.595.353c.427 0 .83-.083 1.213-.21"
            />
            <path
                id="cj"
                fill="url(#a)"
                d="M.922.34C.912.441.891.54.891.643c0 .104.021.202.031.303.009-.101.03-.199.03-.303C.952.54.931.441.922.34"
                mask="url(#b)"
            />
            <path
                id="cp"
                fill="url(#c)"
                d="M1.464.915a3.302 3.302 0 0 0-.084.728c0 .251.031.494.084.729.052-.235.085-.478.085-.729a3.35 3.35 0 0 0-.085-.728"
                mask="url(#d)"
            />
            <path
                id="cv"
                fill="url(#e)"
                d="M.988 2.494c.072-.274.123-.555.123-.851 0-.295-.051-.577-.123-.85-.07.273-.12.555-.12.85 0 .296.05.577.12.851"
                mask="url(#f)"
            />
            <path
                id="cH"
                fill="url(#g)"
                d="M.808.73c-.01.105-.031.206-.031.312 0 .107.021.208.031.312.01-.104.031-.205.031-.312C.839.936.818.835.808.73"
                mask="url(#h)"
            />
            <path
                id="cN"
                fill="url(#i)"
                d="M1.341.192a3.42 3.42 0 0 0-.119.85c0 .296.049.578.119.851a3.32 3.32 0 0 0 .123-.851c0-.295-.051-.577-.123-.85"
                mask="url(#j)"
            />
            <path
                id="cT"
                fill="url(#k)"
                d="M.551.503c.202.036.407.062.619.062.212 0 .417-.026.619-.062A3.24 3.24 0 0 0 1.17.441a3.24 3.24 0 0 0-.619.062"
                mask="url(#l)"
            />
            <path
                id="cW"
                fill="url(#m)"
                d="M.856.892a3.483 3.483 0 0 0-.209 1.15c0 .406.083.789.209 1.152.13-.362.213-.745.213-1.152 0-.405-.083-.789-.213-1.15"
                mask="url(#n)"
            />
            <path
                id="dc"
                fill="url(#o)"
                d="M2.545.513a3.181 3.181 0 0 0-.85-.126c-.296 0-.577.051-.85.126.274.067.556.112.85.112.294 0 .576-.045.85-.112"
                mask="url(#p)"
            />
            <path
                id="df"
                fill="url(#q)"
                d="M1.399.64c-.184.43-.286.904-.286 1.402 0 .499.102.973.286 1.404a3.505 3.505 0 0 0 0-2.806"
                mask="url(#r)"
            />
            <path
                id="dl"
                fill="url(#s)"
                d="M.115.517C.466.628.832.705 1.22.705S1.974.628 2.325.517A3.292 3.292 0 0 0 1.22.314 3.3 3.3 0 0 0 .115.517"
                mask="url(#t)"
            />
            <path
                id="do"
                fill="url(#u)"
                d="M.912 3.591c.227-.47.366-.991.366-1.549 0-.557-.139-1.078-.366-1.548a3.636 3.636 0 0 0-.354 1.548c0 .556.133 1.077.354 1.549"
                mask="url(#v)"
            />
            <path
                id="du"
                fill="url(#w)"
                d="M.512.519c.388.137.799.226 1.233.226.435 0 .846-.089 1.233-.226A3.331 3.331 0 0 0 1.745.278c-.436 0-.85.089-1.233.241"
                mask="url(#x)"
            />
            <path
                id="dx"
                fill="url(#y)"
                d="M1.828.578C1.574.477 1.323.372 1.067.274c.032.518.169 1.003.393 1.442A3.61 3.61 0 0 0 1.828.578"
                mask="url(#z)"
            />
            <path
                id="eb"
                fill="url(#A)"
                d="M1.883.906a3.299 3.299 0 0 0-1.325 0 3.355 3.355 0 0 0 1.325 0"
                mask="url(#B)"
            />
            <path
                id="ee"
                fill="url(#C)"
                d="M.922.865c-.01.101-.031.199-.031.303 0 .104.021.202.031.303.009-.101.03-.199.03-.303 0-.104-.021-.202-.03-.303"
                mask="url(#D)"
            />
            <path
                id="ek"
                fill="url(#E)"
                d="M2.534.906a3.312 3.312 0 0 0-.789-.103c-.273 0-.535.041-.789.103.254.061.516.103.789.103s.535-.042.789-.103"
                mask="url(#F)"
            />
            <path
                id="en"
                fill="url(#G)"
                d="M1.464.439a3.311 3.311 0 0 0-.084.729c0 .251.031.494.084.729.052-.235.085-.478.085-.729S1.516.675 1.464.439"
                mask="url(#H)"
            />
            <path
                id="et"
                fill="url(#I)"
                d="M.359.906c.292.081.593.139.911.139.318 0 .619-.058.911-.139A3.347 3.347 0 0 0 1.27.767C.952.767.651.824.359.906"
                mask="url(#J)"
            />
            <path
                id="ew"
                fill="url(#K)"
                d="M.988 2.018c.072-.273.123-.554.123-.85 0-.296-.051-.577-.123-.85-.07.273-.12.555-.12.85 0 .296.05.577.12.85"
                mask="url(#L)"
            />
            <path
                id="fd"
                fill="url(#M)"
                d="M1.523 1.467c-.101-.01-.199-.031-.303-.031-.104 0-.202.021-.303.031.101.009.199.03.303.03.104 0 .202-.021.303-.03"
                mask="url(#N)"
            />
            <path
                id="fj"
                fill="url(#O)"
                d="M.016 1.45c.236.052.478.084.729.084s.493-.033.729-.084a3.312 3.312 0 0 0-.729-.086c-.251 0-.494.033-.729.086"
                mask="url(#P)"
            />
            <path
                id="fm"
                fill="url(#Q)"
                d="M1.446.39c-.009.102-.03.199-.03.303 0 .104.021.202.03.303.01-.101.031-.199.031-.303 0-.104-.021-.201-.031-.303"
                mask="url(#R)"
            />
            <path
                id="fs"
                fill="url(#S)"
                d="M2.12 1.45a3.311 3.311 0 0 0-.85-.122c-.296 0-.577.05-.85.122.273.07.555.12.85.12a3.4 3.4 0 0 0 .85-.12"
                mask="url(#T)"
            />
            <path
                id="fv"
                fill="url(#U)"
                d="M.988.964a3.436 3.436 0 0 0-.084.729c0 .251.033.494.084.729.053-.235.086-.478.086-.729S1.041 1.2.988.964"
                mask="url(#V)"
            />
            <path
                id="fT"
                fill="url(#W)"
                d="M1.048.992C.947.982.849.961.745.961.641.961.543.982.442.992c.101.009.199.03.303.03.104 0 .202-.021.303-.03"
                mask="url(#X)"
            />
            <path
                id="fZ"
                fill="url(#Y)"
                d="M.541.975c.235.052.478.084.729.084s.494-.032.729-.084A3.305 3.305 0 0 0 1.27.889c-.251 0-.494.033-.729.086"
                mask="url(#Z)"
            />
            <path
                id="gc"
                fill="url(#aa)"
                d="M.971.915c-.009.102-.03.199-.03.303 0 .104.021.202.03.303.01-.101.031-.199.031-.303 0-.104-.021-.201-.031-.303"
                mask="url(#ab)"
            />
            <path
                id="gA"
                fill="url(#ac)"
                d="M1.573.517C1.472.507 1.374.486 1.27.486c-.104 0-.202.021-.303.031.101.009.199.03.303.03.104 0 .202-.021.303-.03"
                mask="url(#ad)"
            />
            <path
                id="kw"
                fill="url(#ae)"
                d="M.497 2.194c.103-.325.175-.666.175-1.026S.6.468.497.142C.403.47.337.81.337 1.168s.066.698.16 1.026"
                mask="url(#af)"
            />
            <path
                id="kC"
                fill="url(#ag)"
                d="M.499 2.592c.08-.288.136-.585.136-.899 0-.313-.056-.611-.136-.898a3.65 3.65 0 0 0-.123.898c0 .312.05.61.123.899"
                mask="url(#ah)"
            />
            <path
                id="kF"
                fill="url(#ai)"
                d="M.322 1.453a3.7 3.7 0 0 0 1.756.457c.639 0 1.23-.175 1.756-.457A3.66 3.66 0 0 0 2.078.991c-.639 0-1.231.177-1.756.462"
                mask="url(#aj)"
            />
            <path
                id="kL"
                fill="url(#ak)"
                d="M.501.447a3.636 3.636 0 0 0-.085.771c0 .265.031.522.085.771.059-.248.098-.504.098-.771A3.33 3.33 0 0 0 .501.447"
                mask="url(#al)"
            />
            <path
                id="kO"
                fill="url(#am)"
                d="M3.751.979A3.618 3.618 0 0 0 2.078.556C1.472.556.909.718.405.979a3.672 3.672 0 0 0 1.673.416c.606 0 1.169-.159 1.673-.416"
                mask="url(#an)"
            />
            <path
                id="kU"
                fill="url(#ao)"
                d="M.511.588C.509.641.496.69.496.743c0 .053.013.103.015.155C.514.846.527.796.527.743.527.69.514.641.511.588"
                mask="url(#ap)"
            />
            <path
                id="kX"
                fill="url(#aq)"
                d="M.529.526c.473.221.994.354 1.549.354.556 0 1.077-.133 1.549-.354A3.552 3.552 0 0 0 2.078.161C1.521.161 1 .299.529.526"
                mask="url(#ar)"
            />
            <path
                id="ld"
                fill="url(#as)"
                d="M3.481 1.039a3.51 3.51 0 0 0-2.806 0 3.565 3.565 0 0 0 2.806 0"
                mask="url(#at)"
            />
            <path
                id="lj"
                fill="url(#au)"
                d="M3.229.582A3.406 3.406 0 0 0 2.078.37c-.406 0-.79.083-1.151.212.363.126.746.209 1.151.209.406 0 .788-.083 1.151-.209"
                mask="url(#av)"
            />
            <path
                id="lp"
                fill="url(#aw)"
                d="M.228 1.097c.273.07.555.119.85.119.295 0 .577-.049.85-.119a3.311 3.311 0 0 0-.85-.122c-.296 0-.577.05-.85.122"
                mask="url(#ax)"
            />
            <path
                id="lv"
                fill="url(#ay)"
                d="M.766.63c.104.01.205.032.312.032.107 0 .208-.022.312-.032-.104-.009-.205-.031-.312-.031C.971.599.87.621.766.63"
                mask="url(#az)"
            />
        </defs>
        <defs>
            <linearGradient id="bM" x1="147.013%" x2="786.615%" y1="147.658%" y2="815.941%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="bP" x1="90.192%" x2="646.013%" y1="96.73%" y2="743.06%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="bS" x1="41.941%" x2="580.799%" y1="40.629%" y2="667.343%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="bV" x1="-3.433%" x2="519.294%" y1="-12.143%" y2="595.811%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="bY" x1="-46.754%" x2="463.879%" y1="-62.531%" y2="531.358%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="cb" x1="-87.309%" x2="408.817%" y1="-108.598%" y2="462.743%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ce" x1="-128.27%" x2="361.888%" y1="-155.304%" y2="406.241%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ch" x1="-168.832%" x2="316.98%" y1="-200.039%" y2="351.766%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="a" x1="-1244.05%" x2="1934.13%" y1="-1455.01%" y2="2241.35%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="cn" x1="-212.078%" x2="275.074%" y1="-249.746%" y2="304.935%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="c" x1="-690.632%" x2="806.498%" y1="-1204.962%" y2="1332.004%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ct" x1="-273.802%" x2="227.172%" y1="-276.208%" y2="251.157%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="e" x1="-589.23%" x2="509.193%" y1="-1214.574%" y2="958.477%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="cz" x1="148.008%" x2="867.379%" y1="111.788%" y2="579.923%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="cC" x1="92.527%" x2="591.692%" y1="76.292%" y2="493.536%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="cF" x1="50.895%" x2="537.376%" y1="44.49%" y2="550.876%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="g" x1="192.2%" x2="3370.38%" y1="215.45%" y2="3911.81%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="cL" x1="8.335%" x2="496.16%" y1="-1.767%" y2="561.85%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="i" x1="3.1%" x2="1101.524%" y1="-42.634%" y2="2130.417%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="cR" x1="-33.853%" x2="451.884%" y1="-51.198%" y2="512.872%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="k" x1="-535.057%" x2="2032.132%" y1="-499.658%" y2="1912.096%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="m" x1="-27.861%" x2="571.886%" y1="-158.371%" y2="1447.346%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="da" x1="-77.522%" x2="410.453%" y1="-95.047%" y2="439.463%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="o" x1="-539.471%" x2="1330.047%" y1="-353.076%" y2="925.941%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="q" x1="-37.749%" x2="365.9%" y1="-236.215%" y2="1081.091%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dj" x1="-128.192%" x2="357.175%" y1="-108.226%" y2="332.565%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="s" x1="-529.05%" x2="909.041%" y1="-254.588%" y2="502.227%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="u" x1="-50.913%" x2="280.444%" y1="-313.281%" y2="880.249%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ds" x1="-219.294%" x2="358.662%" y1="-113.743%" y2="245.759%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="w" x1="-581.427%" x2="707.372%" y1="-247.693%" y2="360.145%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="y" x1="-569.637%" x2="958.802%" y1="-994.501%" y2="1568.856%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dB" x1="133.444%" x2="753.16%" y1="156.78%" y2="920.806%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dE" x1="83.785%" x2="665.443%" y1="89.295%" y2="765.789%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dH" x1="33.779%" x2="589.6%" y1="31.137%" y2="677.58%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dK" x1="-12.727%" x2="525.947%" y1="-22.973%" y2="603.635%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dN" x1="-56.487%" x2="466.24%" y1="-73.845%" y2="534.109%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dQ" x1="-98.583%" x2="412.05%" y1="-122.807%" y2="471.081%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dT" x1="-137.652%" x2="358.473%" y1="-168.224%" y2="408.701%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dW" x1="-175.966%" x2="309.836%" y1="-214.15%" y2="353.386%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="dZ" x1="-216.518%" x2="266.485%" y1="-261.762%" y2="301.622%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="A" x1="-1154.189%" x2="1244.438%" y1="-1007.008%" y2="1098.43%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="C" x1="-1566.65%" x2="1611.53%" y1="-1830.17%" y2="1866.19%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ei" x1="-259.641%" x2="224.538%" y1="-311.643%" y2="253.204%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="E" x1="-1136.882%" x2="877.174%" y1="-824.782%" y2="659.65%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="G" x1="-841.327%" x2="653.75%" y1="-1461.372%" y2="1073.855%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="er" x1="-300.932%" x2="182.133%" y1="-360.95%" y2="203.897%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="I" x1="-1130.132%" x2="614.204%" y1="-703.337%" y2="410.131%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="K" x1="-701.609%" x2="398.107%" y1="-1435.971%" y2="738.359%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="eA" x1="108.011%" x2="661.308%" y1="159.773%" y2="1134.809%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="eD" x1="77.909%" x2="714.309%" y1="82.461%" y2="822.621%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="eG" x1="23.695%" x2="629.409%" y1="19.411%" y2="723.882%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="eJ" x1="-26.008%" x2="555.65%" y1="-38.399%" y2="638.095%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="eM" x1="-71.124%" x2="484.599%" y1="-90.885%" y2="555.558%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="eP" x1="-114.452%" x2="424.405%" y1="-138.997%" y2="481.767%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="eS" x1="-153.676%" x2="369.051%" y1="-96.601%" y2="303.469%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="eV" x1="-190.389%" x2="320.408%" y1="-117.272%" y2="250.804%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="eY" x1="-229.441%" x2="266.684%" y1="-258.067%" y2="287.152%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fb" x1="-270.585%" x2="219.648%" y1="-323.201%" y2="246.961%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="M" x1="-1869.9%" x2="1308.28%" y1="-2182.88%" y2="1513.48%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fh" x1="-309.752%" x2="176.059%" y1="-369.456%" y2="195.564%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="O" x1="-1456.447%" x2="723.374%" y1="-1151.648%" y2="587.19%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="Q" x1="-2166.55%" x2="1011.63%" y1="-2527.88%" y2="1168.48%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fq" x1="-352.468%" x2="133.564%" y1="-419.759%" y2="146.733%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="S" x1="-1405.118%" x2="464.4%" y1="-945.498%" y2="333.519%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="U" x1="-1123.507%" x2="371.569%" y1="-1939.925%" y2="595.302%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fz" x1="64.474%" x2="708.842%" y1="74.732%" y2="911.959%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fC" x1="11.059%" x2="686.692%" y1="4.711%" y2="790.502%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fF" x1="-42.217%" x2="594.183%" y1="-57.249%" y2="682.911%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fI" x1="-90.637%" x2="515.077%" y1="-113.564%" y2="590.907%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fL" x1="-130.492%" x2="439.593%" y1="-167.216%" y2="513.89%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fO" x1="-318.84%" x2="181.828%" y1="-420.977%" y2="188.783%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fR" x1="-363.134%" x2="127.099%" y1="-430.824%" y2="139.338%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="W" x1="-2469.8%" x2="708.38%" y1="-2880.6%" y2="815.76%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="fX" x1="-400.548%" x2="84.373%" y1="-476.099%" y2="88.921%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="Y" x1="-1867.901%" x2="311.92%" y1="-1479.873%" y2="258.965%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="aa" x1="-2766.45%" x2="411.73%" y1="-3225.6%" y2="470.76%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gg" x1="-4.407%" x2="752.663%" y1="-13.275%" y2="867.021%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gj" x1="-64.527%" x2="655.17%" y1="-83.239%" y2="753.989%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gm" x1="-116.473%" x2="559.16%" y1="-143.614%" y2="642.177%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gp" x1="-162.343%" x2="474.057%" y1="-196.962%" y2="543.198%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gs" x1="-106.349%" x2="297.515%" y1="-310.911%" y2="604.482%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gv" x1="-418.461%" x2="77.509%" y1="-495%" y2="82.015%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gy" x1="-454.601%" x2="34.5%" y1="-535.744%" y2="31.789%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ac" x1="-3069.7%" x2="108.48%" y1="-3578.31%" y2="118.05%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gE" x1="-93.629%" x2="734.885%" y1="-117.046%" y2="846.551%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gH" x1="-147.311%" x2="609.759%" y1="-179.478%" y2="701.027%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gK" x1="-200.444%" x2="519.416%" y1="-241.196%" y2="595.842%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gN" x1="-243.88%" x2="431.466%" y1="-291.877%" y2="493.747%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gQ" x1="-416.292%" x2="24.112%" y1="-571.513%" y2="22.375%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gT" x1="-512.254%" x2="-16.129%" y1="-604.027%" y2="-26.921%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gW" x1="-198.869%" x2="706.595%" y1="-239.444%" y2="813.65%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="gZ" x1="-250.018%" x2="578.496%" y1="-298.934%" y2="664.664%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hc" x1="-290.145%" x2="466.744%" y1="-345.681%" y2="534.824%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hf" x1="-336.398%" x2="383.625%" y1="-399.397%" y2="438.02%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hi" x1="-521.154%" x2="-25.509%" y1="-647.679%" y2="-39.725%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hl" x1="-580.511%" x2="-69.878%" y1="-683.313%" y2="-89.425%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ho" x1="-334.348%" x2="686.918%" y1="-397.012%" y2="790.765%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hr" x1="-369.783%" x2="535.681%" y1="-438.225%" y2="614.869%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hu" x1="-406.408%" x2="422.106%" y1="-480.821%" y2="482.776%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hx" x1="-433.118%" x2="323.952%" y1="-511.884%" y2="368.621%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hA" x1="-406.4%" x2="220.264%" y1="-649.846%" y2="331.402%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hD" x1="-583.158%" x2="-52.792%" y1="-970.802%" y2="-111.383%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hG" x1="-622.803%" x2="-84.129%" y1="-732.638%" y2="-106.03%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hJ" x1="-648.502%" x2="-125.775%" y1="-762.385%" y2="-154.431%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hM" x1="-367.298%" x2="503.469%" y1="-607.662%" y2="749.299%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hP" x1="-527.121%" x2="494.145%" y1="-621.215%" y2="566.562%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hS" x1="-540.695%" x2="364.769%" y1="-637.006%" y2="416.088%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hV" x1="-562.797%" x2="265.717%" y1="-662.709%" y2="300.889%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="hY" x1="-576.02%" x2="181.05%" y1="-678.087%" y2="202.418%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ib" x1="-743.769%" x2="111.27%" y1="-631.377%" y2="111.047%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ie" x1="-843.712%" x2="-97.134%" y1="-643.661%" y2="-67.853%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ih" x1="-684.766%" x2="-103.108%" y1="-804.563%" y2="-128.069%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ik" x1="-700.63%" x2="-144.809%" y1="-823.013%" y2="-176.57%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="in" x1="-724.746%" x2="-185.888%" y1="-851.061%" y2="-224.347%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iq" x1="-700.198%" x2="425.219%" y1="-822.841%" y2="486.532%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="it" x1="-719.894%" x2="301.372%" y1="-845.418%" y2="342.359%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iw" x1="-711.61%" x2="193.855%" y1="-835.783%" y2="217.311%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iz" x1="-719.187%" x2="109.327%" y1="-844.596%" y2="119.002%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iC" x1="-718.923%" x2="38.147%" y1="-844.29%" y2="36.215%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iF" x1="-743.77%" x2="-24.074%" y1="-873.407%" y2="-36.179%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iI" x1="-754.131%" x2="-78.497%" y1="-885.238%" y2="-99.447%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iL" x1="-762.972%" x2="-126.572%" y1="-895.519%" y2="-155.358%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iO" x1="-776.619%" x2="-170.905%" y1="-911.412%" y2="-206.941%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iR" x1="-794.559%" x2="-212.901%" y1="-932.257%" y2="-255.763%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iU" x1="-805.546%" x2="-249.725%" y1="-945.035%" y2="-298.592%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="iX" x1="-913.313%" x2="212.902%" y1="-1070.376%" y2="239.461%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ja" x1="-912.049%" x2="108.561%" y1="-1069.277%" y2="118.118%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jd" x1="-882.524%" x2="22.94%" y1="-1034.564%" y2="18.53%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jg" x1="-875.576%" x2="-47.062%" y1="-1026.483%" y2="-62.886%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jj" x1="-861.827%" x2="-104.757%" y1="-1010.493%" y2="-129.988%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jm" x1="-879.841%" x2="-159.982%" y1="-1031.441%" y2="-194.213%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jp" x1="-880.871%" x2="-205.811%" y1="-1033.102%" y2="-247.646%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="js" x1="-883.098%" x2="-246.698%" y1="-1035.23%" y2="-295.07%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jv" x1="-890.953%" x2="-285.239%" y1="-1044.387%" y2="-339.916%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jy" x1="-904.35%" x2="-322.692%" y1="-1059.951%" y2="-383.457%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jB" x1="-1124.24%" x2="1.576%" y1="-1285.604%" y2="-6.379%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jE" x1="-1105.437%" x2="-84.171%" y1="-1293.821%" y2="-106.044%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jH" x1="-1053.439%" x2="-147.974%" y1="-1232.991%" y2="-180.197%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jK" x1="-1031.963%" x2="-203.449%" y1="-1208.05%" y2="-244.704%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jN" x1="-1004.731%" x2="-247.661%" y1="-1176.411%" y2="-296.116%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jQ" x1="-1015.719%" x2="-295.86%" y1="-1189.47%" y2="-352.242%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jT" x1="-1009.194%" x2="-333.561%" y1="-1181.888%" y2="-396.097%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jW" x1="-1003.162%" x2="-366.762%" y1="-1098.075%" y2="-402.674%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="jZ" x1="-1472.888%" x2="-583.292%" y1="-1234.543%" y2="-483.083%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="kc" x1="-1583.053%" x2="-248.244%" y1="-918.331%" y2="-126.137%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="kf" x1="-1342.652%" x2="-281.136%" y1="-780.036%" y2="-144.598%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ki" x1="-1235.286%" x2="-317.797%" y1="-701.375%" y2="-160.443%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="kl" x1="-1196.087%" x2="-358.622%" y1="-631.528%" y2="-168.521%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ko" x1="-1246.781%" x2="-419.776%" y1="-601.092%" y2="-182.367%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="kr" x1="-1556.047%" x2="-578.447%" y1="-744.536%" y2="-259.452%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ku" x1="-358.23%" x2="126.618%" y1="-397.759%" y2="166.14%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ae" x1="-531.72%" x2="223.066%" y1="-1337.856%" y2="463.489%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="kA" x1="-362.68%" x2="86.596%" y1="-393.699%" y2="88.35%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ag" x1="-808.399%" x2="175.799%" y1="-1743.645%" y2="313.317%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ai" x1="-736.817%" x2="168.132%" y1="-210.54%" y2="89.145%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="kJ" x1="-412.761%" x2="41.395%" y1="-455.14%" y2="39.021%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ak" x1="-1251.496%" x2="85.13%" y1="-2283.58%" y2="113.541%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="am" x1="-872.236%" x2="77.609%" y1="-270.542%" y2="59.616%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="kS" x1="-451.659%" x2="-4.783%" y1="-484.895%" y2="-8.933%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ao" x1="-3366.95%" x2="-188.77%" y1="-3924.07%" y2="-227.71%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="aq" x1="-1050.549%" x2="-24.668%" y1="-363.112%" y2="22.021%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lb" x1="-511.831%" x2="-52.158%" y1="-570.006%" y2="-64.074%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="as" x1="-1279.829%" x2="-147.192%" y1="-501.153%" y2="-31.693%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lh" x1="-567.101%" x2="-101.57%" y1="-635.657%" y2="-118.968%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="au" x1="-1711.512%" x2="-330.895%" y1="-839.93%" y2="-142.399%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ln" x1="-628.368%" x2="-153.091%" y1="-721.468%" y2="-181.43%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="aw" x1="-2524.706%" x2="-655.188%" y1="-1711.426%" y2="-432.408%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lt" x1="-698.932%" x2="-209.077%" y1="-817.038%" y2="-250.038%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ay" x1="-4650%" x2="-1471.82%" y1="-5416.32%" y2="-1719.96%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lz" x1="-773.868%" x2="-268.52%" y1="-908.195%" y2="-320.454%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lC" x1="-1229.819%" x2="-478.241%" y1="-1484.598%" y2="-583.925%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lF" x1="-279.128%" x2="49.518%" y1="-564.035%" y2="63.179%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lH" x1="-510.086%" x2="69.349%" y1="-1475.551%" y2="102.741%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lK" x1="-482.684%" x2="73.123%" y1="-1400.918%" y2="113.019%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lN" x1="-366.34%" x2="11.377%" y1="-546.088%" y2="-1.974%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lP" x1="-470.367%" x2="17.248%" y1="-1494.998%" y2="-47.148%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lS" x1="-464.674%" x2="20.475%" y1="-1478.069%" y2="-37.54%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lU" x1="-1263.614%" x2="-11.63%" y1="-742.016%" y2="12.652%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="lX" x1="-1310.062%" x2="-11.454%" y1="-770.022%" y2="12.748%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ma" x1="-3392%" x2="-229.89%" y1="-3959.89%" y2="-282.22%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mc" x1="-580.824%" x2="-43.551%" y1="-1723.318%" y2="-207.378%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mf" x1="-523.785%" x2="13.488%" y1="-1562.374%" y2="-46.434%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mi" x1="-472.194%" x2="-40.972%" y1="-496.555%" y2="-44.923%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mk" x1="-3669.25%" x2="-491.07%" y1="-4275.63%" y2="-579.27%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mn" x1="-3406.45%" x2="-428.86%" y1="-3970.02%" y2="-506.95%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mp" x1="-943.293%" x2="-89.822%" y1="-287.491%" y2="2.393%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ms" x1="-882.402%" x2="-78.734%" y1="-266.809%" y2="6.16%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mu" x1="-1744.265%" x2="-107.647%" y1="-2866.209%" y2="-220.403%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mx" x1="-1801.25%" x2="-260.134%" y1="-2958.338%" y2="-466.921%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mz" x1="-3714.3%" x2="-552.19%" y1="-4324.53%" y2="-646.86%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mC" x1="-3378.6%" x2="-216.49%" y1="-3934.08%" y2="-256.41%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mF" x1="-3488.7%" x2="-511.11%" y1="-4062.14%" y2="-599.07%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mI" x1="-514.078%" x2="-83.956%" y1="-540.452%" y2="-91.23%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mK" x1="-1188.741%" x2="-213.248%" y1="-2550.139%" y2="-502.294%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mN" x1="-1198.625%" x2="-211.121%" y1="-2570.875%" y2="-497.817%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mP" x1="-946.892%" x2="-159.378%" y1="-256.747%" y2="-14.506%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mS" x1="-1024.888%" x2="-173.972%" y1="-280.743%" y2="-19%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mV" x1="-567.651%" x2="-129.981%" y1="-589.579%" y2="-138.648%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="mX" x1="-4308.4%" x2="-1130.22%" y1="-5018.98%" y2="-1322.62%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="na" x1="-4344.5%" x2="-1127.19%" y1="-5061.03%" y2="-1319.16%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="nc" x1="-1039.222%" x2="-242.069%" y1="-299.931%" y2="-43.8%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="nf" x1="-1040.213%" x2="-243.06%" y1="-300.247%" y2="-44.117%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ni" x1="-686.175%" x2="-196.329%" y1="-811.854%" y2="-244.744%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="nk" x1="-1256.613%" x2="-366.378%" y1="-370.445%" y2="-83.953%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="nn" x1="-1257.692%" x2="-367.457%" y1="-370.799%" y2="-84.307%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="nq" x1="-553.147%" x2="-173.8%" y1="-888.435%" y2="-307.039%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ns" x1="-1688.513%" x2="-578.713%" y1="-648.127%" y2="-202.889%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="nv" x1="-1689.893%" x2="-580.093%" y1="-648.676%" y2="-203.438%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <linearGradient id="ny" x1="-906.257%" x2="-332.393%" y1="-1730.003%" y2="-662.118%">
                <stop offset="0%" stop-color="#CDD931" />
                <stop offset="100%" stop-color="#00ADB9" />
            </linearGradient>
            <path id="bB" d="M.06.965h57.487v75.578H.06z" />
            <path id="bD" d="M.995.965h147.047v75.578H.995z" />
            <path id="bF" d="M.793.798h71.015V21.94H.793z" />
            <path id="bH" d="M.353.798h32.439V21.94H.353z" />
            <path id="bJ" d="M.315.798h190.608V21.94H.315z" />
            <path
                id="bL"
                d="M2.545 5.375a2.732 2.732 0 0 0 2.732-2.732c0-.661-.244-1.259-.635-1.732A43.117 43.117 0 0 0 .308 4.205a2.725 2.725 0 0 0 2.237 1.17"
            />
            <path id="bO" d="M3.07.785a2.858 2.858 0 1 0-.002 5.716A2.858 2.858 0 0 0 3.07.785" />
            <path id="bR" d="M3.595 6.592a2.949 2.949 0 1 0 0-5.897 2.949 2.949 0 0 0 0 5.897" />
            <path id="bU" d="M3.12 6.683a3.04 3.04 0 1 0 0-6.08 3.04 3.04 0 0 0 0 6.08" />
            <path id="bX" d="M3.645 6.755a3.112 3.112 0 1 0 0-6.223 3.112 3.112 0 0 0 0 6.223" />
            <path
                id="ca"
                d="M3.551.503a3.201 3.201 0 0 0 .619 6.343A3.203 3.203 0 0 0 4.789.503a3.51 3.51 0 0 1-.619.062 3.51 3.51 0 0 1-.619-.062"
            />
            <path
                id="cd"
                d="M6.922 3.34A3.239 3.239 0 0 0 4.545.513a3.562 3.562 0 0 1-.85.112c-.294 0-.576-.045-.85-.112a3.247 3.247 0 0 0-2.407 3.13A3.257 3.257 0 0 0 3.695 6.9c1.695 0 3.071-1.3 3.227-2.954-.01-.101-.031-.199-.031-.303 0-.103.021-.202.031-.303"
            />
            <path
                id="cg"
                d="M4.883 6.906a3.33 3.33 0 0 0 2.581-2.534 3.304 3.304 0 0 1-.084-.729c0-.25.031-.493.084-.728A3.319 3.319 0 0 0 5.325.517 3.643 3.643 0 0 1 4.22.705c-.388 0-.754-.077-1.105-.188A3.307 3.307 0 0 0 .922 3.34c.009.101.03.2.03.303 0 .104-.021.202-.03.303a3.317 3.317 0 0 0 2.636 2.96 3.281 3.281 0 0 1 1.325 0"
            />
            <path
                id="cm"
                d="M2.512.519A3.36 3.36 0 0 0 .464 2.915c.052.234.085.477.085.728s-.033.494-.085.729a3.362 3.362 0 0 0 2.492 2.534c.254-.062.516-.103.789-.103s.535.041.789.103a3.354 3.354 0 0 0 2.454-2.412 3.414 3.414 0 0 1-.12-.851c0-.295.05-.577.12-.85A3.355 3.355 0 0 0 4.978.519a3.679 3.679 0 0 1-1.233.226C3.311.745 2.9.656 2.512.519"
            />
            <path
                id="cs"
                d="M.988 3.494a3.392 3.392 0 0 0 2.371 2.412c.292-.082.593-.139.911-.139.318 0 .619.057.911.139A3.39 3.39 0 0 0 7.332 4.1 43.235 43.235 0 0 0 1.955.164a3.38 3.38 0 0 0-.967 1.629c.072.273.123.555.123.85 0 .296-.051.577-.123.851"
            />
            <path
                id="cy"
                d="M.652 3.079c.41.196.864.315 1.349.315A3.143 3.143 0 0 0 5.07.922 45.944 45.944 0 0 0 .652 3.079"
            />
            <path
                id="cB"
                d="M6.808 1.73A3.22 3.22 0 0 0 6.547.711 48.768 48.768 0 0 0 .441 2.774a3.24 3.24 0 0 0 3.154 2.513 3.233 3.233 0 0 0 3.213-2.933c-.01-.104-.031-.205-.031-.312 0-.106.021-.207.031-.312"
            />
            <path
                id="cE"
                d="M7.341 2.192A3.32 3.32 0 0 0 6.315.539a51.82 51.82 0 0 0-5.181 1.028A3.301 3.301 0 0 0 .808 2.73c.01.105.031.206.031.312 0 .107-.021.208-.031.312A3.331 3.331 0 0 0 4.12 6.386a3.335 3.335 0 0 0 3.221-2.493 3.407 3.407 0 0 1-.119-.851c0-.294.049-.576.119-.85"
            />
            <path
                id="cK"
                d="M6.856 2.892A3.412 3.412 0 0 0 5.171.994a54.526 54.526 0 0 0-3.489.251A3.418 3.418 0 0 0 .341 3.192c.072.273.123.555.123.85 0 .296-.051.578-.123.851a3.416 3.416 0 0 0 3.304 2.573 3.414 3.414 0 0 0 3.211-2.272 3.495 3.495 0 0 1-.209-1.152c0-.405.083-.788.209-1.15"
            />
            <path
                id="cQ"
                d="M7.399 2.64a3.53 3.53 0 0 0-1.225-1.49A56.083 56.083 0 0 0 2.48.97 3.505 3.505 0 0 0 .856 2.892c.13.361.213.745.213 1.15 0 .407-.083.79-.213 1.152a3.511 3.511 0 0 0 2.695 2.309 3.24 3.24 0 0 1 .619-.062c.212 0 .418.023.619.062a3.52 3.52 0 0 0 2.61-2.057 3.565 3.565 0 0 1-.286-1.404c0-.498.102-.972.286-1.402"
            />
            <path
                id="cZ"
                d="M4.545 6.513a3.576 3.576 0 0 0 2.367-1.922 3.637 3.637 0 0 1-.354-1.549c0-.555.133-1.076.354-1.548-.019-.04-.043-.078-.064-.118A52.41 52.41 0 0 0 1.32.379 3.572 3.572 0 0 0 .399 1.64a3.505 3.505 0 0 1 0 2.806 3.582 3.582 0 0 0 2.446 2.067c.273-.075.554-.126.85-.126.296 0 .578.051.85.126"
            />
            <path
                id="di"
                d="M.912 3.591a3.656 3.656 0 0 0 2.203 1.926 3.3 3.3 0 0 1 1.105-.203c.39 0 .758.08 1.105.203A3.648 3.648 0 0 0 7.46 3.716a3.652 3.652 0 0 1-.393-1.442A49.47 49.47 0 0 0 .962.404C.946.435.927.463.912.494c.227.47.366.991.366 1.548 0 .558-.139 1.079-.366 1.549"
            />
            <path
                id="dr"
                d="M2.512 3.519a3.331 3.331 0 0 1 1.233-.241c.436 0 .85.089 1.233.241.356-.127.685-.303.981-.525A46.231 46.231 0 0 0 .828.578 3.61 3.61 0 0 1 .46 1.716a3.69 3.69 0 0 0 2.052 1.803"
            />
            <path
                id="dA"
                d="M2.02 5.792a2.624 2.624 0 0 0 2.624-2.624c0-.935-.493-1.75-1.23-2.214A41.317 41.317 0 0 0 .08 4.92c.48.532 1.168.872 1.94.872"
            />
            <path id="dD" d="M3.545.436a2.732 2.732 0 1 0 0 5.464 2.732 2.732 0 0 0 0-5.464" />
            <path id="dG" d="M3.07.309a2.859 2.859 0 1 0 0 5.718 2.859 2.859 0 0 0 0-5.718" />
            <path id="dJ" d="M3.595 6.118a2.95 2.95 0 1 0 0-5.899 2.95 2.95 0 0 0 0 5.899" />
            <path id="dM" d="M3.12 6.208a3.04 3.04 0 1 0 0-6.08 3.04 3.04 0 0 0 0 6.08" />
            <path id="dP" d="M3.645 6.28a3.112 3.112 0 1 0 0-6.223 3.112 3.112 0 0 0 0 6.223" />
            <path
                id="dS"
                d="M7.373 4.168A3.202 3.202 0 0 0 4.17.966a3.202 3.202 0 1 0 0 6.405 3.203 3.203 0 0 0 3.203-3.203"
            />
            <path
                id="dV"
                d="M6.922 3.865A3.247 3.247 0 0 0 3.695.912a3.257 3.257 0 1 0 0 6.513c1.695 0 3.071-1.3 3.227-2.954-.01-.101-.031-.199-.031-.303 0-.104.021-.202.031-.303"
            />
            <path
                id="dY"
                d="M4.523 7.467a3.317 3.317 0 0 0 2.941-2.57 3.304 3.304 0 0 1-.084-.729c0-.251.031-.493.084-.729A3.33 3.33 0 0 0 4.883.906a3.355 3.355 0 0 1-1.325 0A3.317 3.317 0 0 0 .922 3.865c.009.101.03.199.03.303 0 .104-.021.202-.03.303a3.307 3.307 0 0 0 2.995 2.996c.101-.01.199-.031.303-.031.104 0 .202.021.303.031"
            />
            <path
                id="eh"
                d="M6.988 5.018a3.4 3.4 0 0 1-.12-.85c0-.295.05-.577.12-.85A3.352 3.352 0 0 0 4.534.906a3.364 3.364 0 0 1-.789.103c-.273 0-.535-.042-.789-.103A3.359 3.359 0 0 0 .464 3.439c.052.236.085.478.085.729s-.033.494-.085.729A3.363 3.363 0 0 0 3.016 7.45c.235-.053.478-.086.729-.086s.493.033.729.086a3.358 3.358 0 0 0 2.514-2.432"
            />
            <path
                id="eq"
                d="M3.359.906A3.389 3.389 0 0 0 .988 3.318c.072.273.123.554.123.85 0 .296-.051.577-.123.85A3.392 3.392 0 0 0 3.42 7.45c.273-.072.554-.122.85-.122.296 0 .577.05.85.122a3.389 3.389 0 0 0 2.377-2.256 3.704 3.704 0 0 1-.16-1.026c0-.358.066-.698.16-1.026A3.386 3.386 0 0 0 5.181.906a3.386 3.386 0 0 1-.911.139c-.318 0-.619-.058-.911-.139"
            />
            <path
                id="ez"
                d="M1.013 4.045a2.352 2.352 0 0 0 2.352-2.352A2.33 2.33 0 0 0 2.861.254 41 41 0 0 0 .863 4.03c.05.004.099.015.15.015"
            />
            <path id="eC" d="M3.02.196a2.497 2.497 0 1 0 0 4.994 2.497 2.497 0 0 0 0-4.994" />
            <path id="eF" d="M3.545.07a2.623 2.623 0 1 0 0 5.247 2.624 2.624 0 0 0 0-5.247" />
            <path id="eI" d="M3.07.961a2.732 2.732 0 1 0 0 5.464 2.732 2.732 0 0 0 0-5.464" />
            <path id="eL" d="M6.454 3.693a2.859 2.859 0 1 0-5.718 0 2.859 2.859 0 0 0 5.718 0" />
            <path
                id="eO"
                d="M3.12.744A2.949 2.949 0 0 0 .171 3.693a2.946 2.946 0 0 0 2.395 2.893 19.106 19.106 0 0 1 3.165-1.548c.209-.405.338-.857.338-1.345A2.949 2.949 0 0 0 3.12.744"
            />
            <path
                id="eR"
                d="M3.645.653a3.04 3.04 0 0 0-3.04 3.04c0 .338.069.657.17.961 1.824-.579 3.805-.901 5.91-.962A3.041 3.041 0 0 0 3.645.653"
            />
            <path
                id="eU"
                d="M6.183 4.436c.059-.239.099-.485.099-.743A3.112 3.112 0 0 0 .06 3.674c.108-.002.21-.016.319-.016 2.066 0 3.997.285 5.804.778"
            />
            <path
                id="eX"
                d="M6.898 3.693A3.202 3.202 0 0 0 3.695.491 3.202 3.202 0 0 0 .492 3.693c0 .298.054.581.13.855a19.266 19.266 0 0 1 4.504 1.996 3.191 3.191 0 0 0 1.772-2.851"
            />
            <path
                id="fa"
                d="M7.446 3.39A3.234 3.234 0 0 0 4.523.467c-.101.009-.199.03-.303.03-.104 0-.202-.021-.303-.03A3.246 3.246 0 0 0 .963 3.693 3.257 3.257 0 0 0 4.22 6.95a3.245 3.245 0 0 0 3.226-2.954c-.009-.101-.03-.199-.03-.303 0-.104.021-.201.03-.303"
            />
            <path
                id="fg"
                d="M4.048 6.992a3.316 3.316 0 0 0 2.94-2.57 3.429 3.429 0 0 1-.084-.729c0-.251.033-.493.084-.729A3.323 3.323 0 0 0 4.474.45a3.436 3.436 0 0 1-.729.084c-.251 0-.493-.032-.729-.084a3.316 3.316 0 0 0-2.57 2.94c.01.102.031.199.031.303 0 .104-.021.202-.031.303a3.308 3.308 0 0 0 2.996 2.996c.101-.01.199-.031.303-.031.104 0 .202.021.303.031"
            />
            <path
                id="fp"
                d="M7.499 4.592a3.651 3.651 0 0 1-.123-.899c0-.311.05-.609.123-.898A3.352 3.352 0 0 0 5.12.45a3.4 3.4 0 0 1-.85.12c-.295 0-.577-.05-.85-.12A3.358 3.358 0 0 0 .988 2.964c.053.236.086.478.086.729s-.033.494-.086.729a3.366 3.366 0 0 0 2.553 2.553c.235-.053.478-.086.729-.086s.494.033.729.086a3.357 3.357 0 0 0 2.5-2.383"
            />
            <path
                id="fy"
                d="M2.495 4.426a2.208 2.208 0 0 0 0-4.415c-.179 0-.351.027-.518.068A42.24 42.24 0 0 0 .75 3.555a2.194 2.194 0 0 0 1.745.871"
            />
            <path id="fB" d="M3.02.866a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704" />
            <path id="fE" d="M2.545.721a2.497 2.497 0 1 0 0 4.994 2.497 2.497 0 0 0 0-4.994" />
            <path id="fH" d="M3.07.595a2.623 2.623 0 1 0 0 5.247 2.624 2.624 0 0 0 0-5.247" />
            <path
                id="fK"
                d="M3.595.486A2.732 2.732 0 0 0 .863 3.218a2.724 2.724 0 0 0 2.363 2.695 19.557 19.557 0 0 1 2.92-3.65A2.725 2.725 0 0 0 3.595.486"
            />
            <path
                id="fN"
                d="M3.22.016A3.19 3.19 0 0 0 .634 1.343a19.429 19.429 0 0 1 4.001 4.735 3.193 3.193 0 0 0 1.788-2.86A3.203 3.203 0 0 0 3.22.016"
            />
            <path
                id="fQ"
                d="M6.971 3.915A3.234 3.234 0 0 0 4.048.992c-.101.009-.199.03-.303.03-.104 0-.202-.021-.303-.03A3.246 3.246 0 0 0 .488 4.218a3.257 3.257 0 0 0 3.257 3.257 3.244 3.244 0 0 0 3.226-2.954c-.009-.101-.03-.199-.03-.303 0-.104.021-.201.03-.303"
            />
            <path
                id="fW"
                d="M4.573 7.517a3.317 3.317 0 0 0 2.928-2.528 3.628 3.628 0 0 1-.085-.771c0-.264.031-.522.085-.771A3.324 3.324 0 0 0 4.999.975a3.365 3.365 0 0 1-.729.084c-.251 0-.494-.032-.729-.084a3.316 3.316 0 0 0-2.57 2.94c.01.102.031.199.031.303 0 .104-.021.202-.031.303a3.308 3.308 0 0 0 2.996 2.996c.101-.01.199-.031.303-.031.104 0 .202.021.303.031"
            />
            <path id="gf" d="M2.495 4.842a2.1 2.1 0 1 0 0-4.199 2.1 2.1 0 0 0 0 4.199" />
            <path id="gi" d="M3.02.536a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414" />
            <path id="gl" d="M2.545.391a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704" />
            <path id="go" d="M3.07.246a2.497 2.497 0 1 0 0 4.994 2.497 2.497 0 0 0 0-4.994" />
            <path
                id="gr"
                d="M.454 2.743c0 .547.168 1.054.454 1.475.41-1.422.955-2.77 1.618-4.038A2.623 2.623 0 0 0 .454 2.743"
            />
            <path id="gu" d="M3.745.54a3.203 3.203 0 1 0 .001 6.405A3.203 3.203 0 0 0 3.745.54" />
            <path
                id="gx"
                d="M6.511 3.588A3.238 3.238 0 0 0 3.573.517c-.101.009-.199.03-.303.03-.104 0-.202-.021-.303-.03A3.246 3.246 0 0 0 .013 3.743 3.257 3.257 0 0 0 3.27 7a3.249 3.249 0 0 0 3.241-3.102c-.002-.052-.015-.102-.015-.155 0-.053.013-.102.015-.155"
            />
            <path id="gD" d="M2.495.35a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837" />
            <path id="gG" d="M3.02.169a2.1 2.1 0 1 0 0 4.199 2.1 2.1 0 0 0 0-4.199" />
            <path id="gJ" d="M2.545.061a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414" />
            <path id="gM" d="M3.07.916a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704" />
            <path
                id="gP"
                d="M2.745.156c-.891 0-1.689.379-2.256.979.191 1.243.306 2.518.306 3.83 0 .232-.023.456-.03.686.54.449 1.224.729 1.98.729a3.112 3.112 0 1 0 0-6.224"
            />
            <path id="gS" d="M3.27.066a3.202 3.202 0 1 0 0 6.406 3.202 3.202 0 0 0 0-6.406" />
            <path id="gV" d="M2.495.038a1.755 1.755 0 1 0 0 3.51 1.755 1.755 0 0 0 0-3.51" />
            <path id="gY" d="M2.02.875a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837" />
            <path id="hb" d="M2.545.694a2.098 2.098 0 1 0 0 4.197 2.098 2.098 0 0 0 0-4.197" />
            <path id="he" d="M3.07.586A2.207 2.207 0 1 0 3.07 5a2.207 2.207 0 0 0 0-4.414" />
            <path
                id="hh"
                d="M2.745.753a3.02 3.02 0 0 0-2.101.851A24.004 24.004 0 0 1 .02 5.117a3.032 3.032 0 0 0 5.765-1.324 3.04 3.04 0 0 0-3.04-3.04"
            />
            <path id="hk" d="M3.27.681a3.112 3.112 0 1 0 0 6.223 3.112 3.112 0 0 0 0-6.223" />
            <path id="hn" d="M2.495.762a1.556 1.556 0 1 0 0 3.113 1.556 1.556 0 0 0 0-3.113" />
            <path id="hq" d="M2.02.563a1.755 1.755 0 1 0 0 3.51 1.755 1.755 0 0 0 0-3.51" />
            <path id="ht" d="M2.545.4a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837" />
            <path id="hw" d="M3.07.219a2.1 2.1 0 1 0 0 4.199 2.1 2.1 0 0 0 0-4.199" />
            <path
                id="hz"
                d="M2.595 4.525c.206 0 .402-.037.591-.09A20.449 20.449 0 0 1 1.034.758a2.206 2.206 0 0 0 1.561 3.767"
            />
            <path
                id="hC"
                d="M1.22 5.177a2.859 2.859 0 0 0 2.859-2.859A2.83 2.83 0 0 0 3.675.876 20.168 20.168 0 0 1 .992 5.154c.077.006.15.023.228.023"
            />
            <path id="hF" d="M3.745.369a2.949 2.949 0 1 0 0 5.899 2.95 2.95 0 0 0 0-5.899" />
            <path id="hI" d="M3.27.278a3.04 3.04 0 1 0 0 6.08 3.04 3.04 0 0 0 0-6.08" />
            <path
                id="hL"
                d="M2.906 1.843A1.41 1.41 0 0 0 1.495.432a1.38 1.38 0 0 0-.622.16c.343.872.712 1.727 1.108 2.564a1.4 1.4 0 0 0 .925-1.313"
            />
            <path id="hO" d="M2.02.287a1.556 1.556 0 1 0 0 3.113 1.556 1.556 0 0 0 0-3.113" />
            <path id="hR" d="M2.545.088a1.755 1.755 0 1 0 0 3.51 1.755 1.755 0 0 0 0-3.51" />
            <path id="hU" d="M2.07.925a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837" />
            <path id="hX" d="M2.595.744a2.1 2.1 0 1 0 0 4.199 2.1 2.1 0 0 0 0-4.199" />
            <path
                id="ia"
                d="M.913.843c0 1.22.988 2.208 2.207 2.208.586 0 1.115-.233 1.51-.605A18.863 18.863 0 0 1 .995.276C.947.458.913.646.913.843"
            />
            <path
                id="id"
                d="M1.695 3.467A2.624 2.624 0 0 0 4.319.843c0-.068-.015-.132-.02-.199-1.285.913-2.71 1.652-4.237 2.237a2.596 2.596 0 0 0 1.633.586"
            />
            <path
                id="ig"
                d="M3.22.111c-.553 0-1.065.167-1.495.449-.247.248-.491.499-.752.732A2.732 2.732 0 1 0 3.22.111"
            />
            <path id="ij" d="M3.745.984a2.859 2.859 0 1 0 0 5.718 2.859 2.859 0 0 0 0-5.718" />
            <path id="im" d="M3.27.894a2.949 2.949 0 1 0 0 5.897 2.949 2.949 0 0 0 0-5.897" />
            <path id="ip" d="M3.431 2.369a1.41 1.41 0 1 0-2.822-.002 1.41 1.41 0 0 0 2.822.002" />
            <path id="is" d="M2.545.812a1.557 1.557 0 1 0 .001 3.113A1.557 1.557 0 0 0 2.545.812" />
            <path id="iv" d="M2.07.613a1.756 1.756 0 1 0 .001 3.511A1.756 1.756 0 0 0 2.07.613" />
            <path id="iy" d="M2.595.45a1.919 1.919 0 1 0 .001 3.837A1.919 1.919 0 0 0 2.595.45" />
            <path id="iB" d="M2.12.269a2.1 2.1 0 1 0 .001 4.2 2.1 2.1 0 0 0-.001-4.2" />
            <path id="iE" d="M2.645.161a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414" />
            <path id="iH" d="M3.17.016a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704" />
            <path id="iK" d="M2.695.871a2.497 2.497 0 1 0 0 4.995 2.497 2.497 0 0 0 0-4.995" />
            <path id="iN" d="M3.22.745a2.624 2.624 0 1 0 0 5.247 2.624 2.624 0 0 0 0-5.247" />
            <path id="iQ" d="M2.745.636a2.732 2.732 0 1 0 0 5.464 2.732 2.732 0 0 0 0-5.464" />
            <path id="iT" d="M3.27.509a2.86 2.86 0 1 0 0 5.718 2.86 2.86 0 0 0 0-5.718" />
            <path id="iW" d="M1.545.482a1.411 1.411 0 1 0 0 2.823 1.411 1.411 0 0 0 0-2.823" />
            <path id="iZ" d="M2.07.337a1.556 1.556 0 1 0 0 3.113 1.556 1.556 0 0 0 0-3.113" />
            <path id="jc" d="M2.595.138a1.755 1.755 0 1 0 0 3.51 1.755 1.755 0 0 0 0-3.51" />
            <path id="jf" d="M2.12.975a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837" />
            <path id="ji" d="M2.645.794a2.1 2.1 0 1 0 0 4.199 2.1 2.1 0 0 0 0-4.199" />
            <path id="jl" d="M3.17.686a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414" />
            <path id="jo" d="M2.695.54a2.353 2.353 0 1 0 .002 4.706A2.353 2.353 0 0 0 2.695.54" />
            <path id="jr" d="M3.22.396a2.497 2.497 0 1 0 0 4.994 2.497 2.497 0 0 0 0-4.994" />
            <path id="ju" d="M2.745.27a2.623 2.623 0 1 0-.001 5.247A2.623 2.623 0 0 0 2.745.27" />
            <path id="jx" d="M3.27.161a2.732 2.732 0 1 0 0 5.464 2.732 2.732 0 0 0 0-5.464" />
            <path
                id="jA"
                d="M3.482 1.418a1.412 1.412 0 0 0-2.823 0c0 .176.041.341.1.497.535.294 1.08.576 1.629.85.621-.147 1.094-.681 1.094-1.347"
            />
            <path id="jD" d="M1.595.069a1.556 1.556 0 1 0 0 3.112 1.556 1.556 0 0 0 0-3.112" />
            <path id="jG" d="M2.12.871a1.754 1.754 0 1 0-.001 3.509A1.754 1.754 0 0 0 2.12.871" />
            <path id="jJ" d="M2.645.708a1.918 1.918 0 1 0-.001 3.835A1.918 1.918 0 0 0 2.645.708" />
            <path id="jM" d="M2.17.665a2.098 2.098 0 1 0-.001 4.197A2.098 2.098 0 0 0 2.17.665" />
            <path id="jP" d="M2.695.487a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414" />
            <path id="jS" d="M3.22.066a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704" />
            <path
                id="jV"
                d="M2.745.921A2.498 2.498 0 0 0 .248 3.418c0 .954.542 1.775 1.33 2.195a45.756 45.756 0 0 0 3.626-1.816c.019-.125.038-.249.038-.379A2.498 2.498 0 0 0 2.745.921"
            />
            <path
                id="jY"
                d="M.453 3.077A43.866 43.866 0 0 0 4.293.486 2.806 2.806 0 0 0 3.27.288 2.818 2.818 0 0 0 .453 3.077"
            />
            <path
                id="kb"
                d="M1.526.53C1.129.53.773.696.517.959c.782.282 1.576.542 2.381.786C2.798 1.063 2.236.53 1.526.53"
            />
            <path
                id="ke"
                d="M2.12.754c-.656 0-1.212.409-1.441.985.984.216 1.985.396 2.994.556A1.555 1.555 0 0 0 2.12.754"
            />
            <path
                id="kh"
                d="M2.645.188c-.888 0-1.593.671-1.709 1.527 1.141.111 2.296.188 3.464.229v-.001C4.4.974 3.614.188 2.645.188"
            />
            <path
                id="kk"
                d="M2.17.163C1.15.163.324.962.264 1.967a56.41 56.41 0 0 0 3.795-.178A1.915 1.915 0 0 0 2.17.163"
            />
            <path
                id="kn"
                d="M2.695.844A2.1 2.1 0 0 0 .64 2.517a53.462 53.462 0 0 0 3.843-.659A2.09 2.09 0 0 0 2.695.844"
            />
            <path
                id="kq"
                d="M.673 2.095A48.586 48.586 0 0 0 3.924 1.07 2.195 2.195 0 0 0 2.718.708C1.79.708.999 1.284.673 2.095"
            />
            <path
                id="kt"
                d="M.497 5.194c.281.98.944 1.787 1.825 2.259a3.664 3.664 0 0 1 1.756-.462 3.66 3.66 0 0 1 1.756.462 3.725 3.725 0 0 0 1.218-1.037A41.35 41.35 0 0 0 2.294.898 3.725 3.725 0 0 0 .497 3.142c.103.326.175.666.175 1.026S.6 4.869.497 5.194"
            />
            <path
                id="kz"
                d="M2.322.453A3.685 3.685 0 0 0 .499 2.795c.08.287.136.585.136.898 0 .314-.056.611-.136.899a3.693 3.693 0 0 0 1.906 2.387 3.621 3.621 0 0 1 1.673-.423c.606 0 1.17.162 1.673.423a3.694 3.694 0 0 0 1.822-2.115 3.703 3.703 0 0 1-.206-1.171c0-.411.083-.8.206-1.171A3.682 3.682 0 0 0 5.834.453 3.697 3.697 0 0 1 4.078.91 3.7 3.7 0 0 1 2.322.453"
            />
            <path
                id="kI"
                d="M7.499 5.495a3.826 3.826 0 0 1-.236-1.277c0-.449.094-.874.236-1.276A3.648 3.648 0 0 0 5.751.979a3.666 3.666 0 0 1-1.673.416A3.672 3.672 0 0 1 2.405.979 3.648 3.648 0 0 0 .501 3.447c.059.249.098.505.098.771 0 .267-.039.523-.098.771a3.657 3.657 0 0 0 2.028 2.537 3.552 3.552 0 0 1 1.549-.365c.557 0 1.078.138 1.549.365a3.663 3.663 0 0 0 1.872-2.031"
            />
            <path
                id="kR"
                d="M5.481 7.039a3.57 3.57 0 0 0 2.142-2.922c-.013-.124-.039-.246-.039-.374s.026-.249.039-.374A3.566 3.566 0 0 0 5.627.526 3.637 3.637 0 0 1 4.078.88 3.644 3.644 0 0 1 2.529.526 3.567 3.567 0 0 0 .511 3.588c.003.053.016.102.016.155 0 .053-.013.103-.016.155a3.577 3.577 0 0 0 2.164 3.141 3.51 3.51 0 0 1 2.806 0"
            />
            <path
                id="la"
                d="M5.229 6.582a3.504 3.504 0 0 0 2.24-2.411 3.794 3.794 0 0 1-.119-.903c0-.312.048-.611.119-.902A3.517 3.517 0 0 0 5.481.039a3.565 3.565 0 0 1-2.806 0 3.522 3.522 0 0 0-2.12 3.229 3.51 3.51 0 0 0 2.372 3.314 3.406 3.406 0 0 1 1.151-.212c.406 0 .79.083 1.151.212"
            />
            <path
                id="lg"
                d="M7.482 3.601A3.406 3.406 0 0 0 5.229.582a3.489 3.489 0 0 1-1.151.209c-.405 0-.788-.083-1.151-.209A3.416 3.416 0 0 0 .655 3.793a3.415 3.415 0 0 0 2.573 3.304c.273-.072.554-.122.85-.122.296 0 .577.05.85.122a3.408 3.408 0 0 0 2.554-3.112c-.003-.065-.02-.126-.02-.192s.017-.127.02-.192"
            />
            <path
                id="lm"
                d="M3.228.097A3.335 3.335 0 0 0 .735 3.318 3.331 3.331 0 0 0 3.766 6.63c.104-.009.205-.031.312-.031.107 0 .208.022.312.031a3.332 3.332 0 0 0 3.032-3.312A3.335 3.335 0 0 0 4.928.097c-.273.07-.555.119-.85.119-.295 0-.577-.049-.85-.119"
            />
            <path
                id="ls"
                d="M3.766.63A3.233 3.233 0 0 0 .834 3.843a3.244 3.244 0 1 0 6.488 0A3.233 3.233 0 0 0 4.39.63c-.104.01-.205.032-.312.032-.107 0-.208-.022-.312-.032"
            />
            <path id="ly" d="M3.078.426a2.942 2.942 0 1 0 0 5.884 2.942 2.942 0 0 0 0-5.884" />
            <path
                id="lB"
                d="M.073 3.893a3 3 0 0 0 .214 1.099 41.589 41.589 0 0 0 3.769-3.927 2.938 2.938 0 0 0-.978-.177A3.005 3.005 0 0 0 .073 3.893"
            />
            <path
                id="lE"
                d="M.573 3.864a3.87 3.87 0 0 0 1.555 2.035 4.116 4.116 0 0 1 1.89-.609A41.268 41.268 0 0 0 1.291.246a3.785 3.785 0 0 0-.718 1.276c.124.37.207.759.207 1.171 0 .412-.083.801-.207 1.171"
            />
            <path
                id="lM"
                d="M2.128.899A3.965 3.965 0 0 0 .499 2.942c.149.398.241.826.241 1.276 0 .451-.092.878-.241 1.277.326.926.99 1.689 1.856 2.163a3.795 3.795 0 0 1 1.981-.562c.583 0 1.128.14 1.62.371a3.832 3.832 0 0 1-.204-1.178c0-.368.069-.718.166-1.057A42.2 42.2 0 0 0 4.563 1.53c-.077.004-.149.022-.227.022A4.029 4.029 0 0 1 2.128.899"
            />
            <path
                id="lZ"
                d="M1.644.887c-.029-.119-.052-.24-.082-.358-.077.049-.164.084-.244.129.114.069.22.148.326.229"
            />
            <path
                id="mh"
                d="M4.336 1.178a4.122 4.122 0 0 1-1.981-.52A3.616 3.616 0 0 0 .623 3.369c.013.125.038.246.038.374s-.025.25-.038.374a3.615 3.615 0 0 0 1.823 2.759 4.03 4.03 0 0 1 1.89-.483c.689 0 1.326.185 1.891.483a3.686 3.686 0 0 0 1.301-1.238 45.391 45.391 0 0 0-.618-3.59c-.36-.36-.65-.783-.85-1.255a4.13 4.13 0 0 1-1.724.385"
            />
            <path
                id="mH"
                d="M2.446.876c-.979.517-1.71 1.41-1.977 2.49.078.289.132.588.132.902 0 .314-.054.613-.132.903a3.877 3.877 0 0 0 1.849 2.422 3.92 3.92 0 0 1 2.018-.565 3.92 3.92 0 0 1 2.018.565 3.906 3.906 0 0 0 1.595-1.709 49.255 49.255 0 0 0-.14-3.484A3.935 3.935 0 0 0 6.227.876a3.79 3.79 0 0 1-1.891.514 3.783 3.783 0 0 1-1.89-.514"
            />
            <path
                id="mU"
                d="M6.143 7.105a3.83 3.83 0 0 0 1.293-1.074c.186-1.253.312-2.535.397-3.834A3.796 3.796 0 0 0 6.354.593a4.037 4.037 0 0 1-2.018.55c-.74 0-1.424-.209-2.018-.55A3.73 3.73 0 0 0 .482 3.601c.004.065.02.126.02.192s-.016.127-.02.192c.072 1.359.879 2.516 2.047 3.12a3.832 3.832 0 0 1 1.807-.465 3.83 3.83 0 0 1 1.807.465"
            />
            <path
                id="nh"
                d="M5.64 6.517A43.461 43.461 0 0 0 7.12.845a3.766 3.766 0 0 0-.977-.74 3.92 3.92 0 0 1-1.807.454A3.92 3.92 0 0 1 2.529.105C1.357.73.552 1.927.552 3.318c0 1.475.899 2.739 2.189 3.325a3.715 3.715 0 0 1 1.595-.369c.461 0 .898.093 1.304.243"
            />
            <path
                id="np"
                d="M4.336.996A3.839 3.839 0 0 1 2.741.643C1.516 1.221.665 2.431.665 3.843c0 1.439.881 2.671 2.142 3.236A41.578 41.578 0 0 0 5.549.786c-.383.127-.786.21-1.213.21"
            />
            <path
                id="nx"
                d="M.484 3.524c0 .107.023.208.033.312A41.164 41.164 0 0 0 2.674.332C1.388.853.484 2.085.484 3.524"
            />
            <use id="ck" xlink:href="#aA" />
            <use id="cq" xlink:href="#aB" />
            <use id="cw" xlink:href="#aC" />
            <use id="cI" xlink:href="#aD" />
            <use id="cO" xlink:href="#aE" />
            <use id="cU" xlink:href="#aF" />
            <use id="cX" xlink:href="#aG" />
            <use id="dd" xlink:href="#aH" />
            <use id="dg" xlink:href="#aI" />
            <use id="dm" xlink:href="#aJ" />
            <use id="dp" xlink:href="#aK" />
            <use id="dv" xlink:href="#aL" />
            <use id="dy" xlink:href="#aM" />
            <use id="ec" xlink:href="#aN" />
            <use id="ef" xlink:href="#aO" />
            <use id="el" xlink:href="#aP" />
            <use id="eo" xlink:href="#aQ" />
            <use id="eu" xlink:href="#aR" />
            <use id="ex" xlink:href="#aS" />
            <use id="fe" xlink:href="#aT" />
            <use id="fk" xlink:href="#aU" />
            <use id="fn" xlink:href="#aV" />
            <use id="ft" xlink:href="#aW" />
            <use id="fw" xlink:href="#aX" />
            <use id="fU" xlink:href="#aY" />
            <use id="ga" xlink:href="#aZ" />
            <use id="gd" xlink:href="#ba" />
            <use id="gB" xlink:href="#bb" />
            <use id="kx" xlink:href="#bc" />
            <use id="kD" xlink:href="#bd" />
            <use id="kG" xlink:href="#be" />
            <use id="kM" xlink:href="#bf" />
            <use id="kP" xlink:href="#bg" />
            <use id="kV" xlink:href="#bh" />
            <use id="kY" xlink:href="#bi" />
            <use id="le" xlink:href="#bj" />
            <use id="lk" xlink:href="#bk" />
            <use id="lq" xlink:href="#bl" />
            <use id="lw" xlink:href="#bm" />
            <use id="lJ" xlink:href="#bn" />
            <use id="lR" xlink:href="#bo" />
            <use id="lW" xlink:href="#bp" />
            <use id="me" xlink:href="#bq" />
            <use id="mm" xlink:href="#br" />
            <use id="mr" xlink:href="#bs" />
            <use id="mw" xlink:href="#bt" />
            <use id="mB" xlink:href="#bu" />
            <use id="mE" xlink:href="#bu" />
            <use id="mM" xlink:href="#bv" />
            <use id="mR" xlink:href="#bw" />
            <use id="mZ" xlink:href="#bx" />
            <use id="ne" xlink:href="#by" />
            <use id="nm" xlink:href="#bz" />
            <use id="nu" xlink:href="#bA" />
        </defs>
        <g fill="none" fill-rule="evenodd">
            <g transform="translate(0 5)">
                <mask id="bC" fill="#fff">
                    <use xlink:href="#bB" />
                </mask>
                <path
                    fill="#211B19"
                    d="M16.625 15.972v16.304h33.459v15.007H16.625v29.26H0V.965h57.547v15.007H16.625"
                    mask="url(#bC)"
                />
            </g>
            <path
                fill="#211B19"
                d="M233.165 74.957a35.914 35.914 0 0 1-6.857 4.266c-2.484 1.186-5.201 2.086-8.152 2.699-2.952.612-6.262.916-9.934.916-5.544 0-10.689-1.007-15.439-3.022-4.75-2.015-8.855-4.769-12.31-8.259-3.455-3.491-6.152-7.613-8.096-12.363-1.944-4.751-2.916-9.827-2.916-15.223v-.217c0-5.399.972-10.455 2.916-15.17 1.944-4.714 4.641-8.854 8.096-12.416 3.455-3.564 7.596-6.371 12.417-8.422 4.822-2.051 10.15-3.079 15.981-3.079 3.527 0 6.748.29 9.664.866 2.913.577 5.559 1.368 7.936 2.373a34.69 34.69 0 0 1 6.585 3.672 44.422 44.422 0 0 1 5.615 4.751l-10.582 12.202c-2.952-2.664-5.956-4.753-9.015-6.264-3.061-1.511-6.498-2.267-10.312-2.267-3.168 0-6.099.613-8.798 1.837-2.7 1.224-5.021 2.913-6.965 5.074-1.944 2.16-3.455 4.661-4.534 7.503-1.081 2.844-1.621 5.885-1.621 9.124v.216c0 3.239.54 6.3 1.621 9.178 1.079 2.88 2.573 5.399 4.481 7.557 1.906 2.16 4.211 3.87 6.908 5.129 2.699 1.26 5.669 1.888 8.908 1.888 4.32 0 7.972-.789 10.958-2.374 2.988-1.582 5.957-3.742 8.909-6.478l10.582 10.689a54.692 54.692 0 0 1-6.046 5.614m84.402-11.336c-1.549 4.247-3.763 7.791-6.641 10.635-2.879 2.845-6.371 4.967-10.472 6.369-4.104 1.405-8.676 2.107-13.714 2.107-10.148 0-18.139-2.81-23.968-8.422-5.832-5.615-8.745-14-8.745-25.157V5.965h16.627v42.756c0 6.191 1.438 10.852 4.318 13.981 2.878 3.132 6.872 4.697 11.984 4.697s9.106-1.511 11.986-4.534c2.878-3.023 4.318-7.559 4.318-13.605V5.965h16.628v42.647c0 5.76-.774 10.762-2.321 15.009m75.619 5.559c-1.36 2.916-3.254 5.364-5.686 7.344-2.433 1.979-5.333 3.49-8.704 4.533-3.374 1.044-7.11 1.565-11.213 1.565-5.758 0-11.409-.99-16.951-2.969-5.544-1.977-10.582-5.02-15.117-9.121l9.827-11.771c3.456 2.809 7 5.041 10.633 6.694 3.636 1.657 7.613 2.484 11.933 2.484 3.453 0 6.135-.629 8.043-1.888 1.906-1.26 2.86-3.005 2.86-5.237v-.216c0-1.081-.199-2.033-.595-2.862-.398-.827-1.156-1.601-2.273-2.321-1.119-.72-2.671-1.44-4.656-2.16-1.985-.717-4.565-1.473-7.739-2.267-3.828-.934-7.29-1.98-10.395-3.132-3.103-1.15-5.737-2.572-7.9-4.265-2.168-1.689-3.845-3.796-5.036-6.315-1.19-2.519-1.786-5.651-1.786-9.394v-.216c0-3.455.642-6.567 1.929-9.34a21.29 21.29 0 0 1 5.417-7.178c2.325-2.015 5.102-3.565 8.328-4.644 3.226-1.081 6.783-1.62 10.671-1.62 5.542 0 10.636.829 15.276 2.483a44.321 44.321 0 0 1 12.796 7.127l-8.638 12.524c-3.384-2.303-6.695-4.12-9.933-5.453-3.239-1.331-6.478-1.998-9.718-1.998-3.238 0-5.668.631-7.287 1.891-1.62 1.259-2.43 2.827-2.43 4.697v.216c0 1.224.235 2.285.703 3.186.47.9 1.318 1.71 2.545 2.427 1.226.722 2.905 1.405 5.035 2.053 2.13.647 4.816 1.402 8.065 2.267 3.824 1.008 7.235 2.143 10.232 3.402 2.992 1.26 5.518 2.771 7.577 4.534 2.055 1.763 3.607 3.832 4.653 6.209 1.046 2.374 1.572 5.218 1.572 8.528v.217c0 3.742-.681 7.071-2.038 9.986"
            />
            <g transform="translate(413 5)">
                <mask id="bE" fill="#fff">
                    <use xlink:href="#bD" />
                </mask>
                <path
                    fill="#211B19"
                    d="M.995 76.543V.965h56.9v14.791H17.406v15.332h35.629v14.793H17.406V61.75h41.028v14.793H.995m129.664-37.789c0-3.31-.56-6.371-1.674-9.177-1.117-2.807-2.664-5.219-4.641-7.234-1.982-2.015-4.374-3.58-7.18-4.697-2.809-1.114-5.904-1.674-9.287-1.674H95.028v45.565h12.849c3.383 0 6.478-.542 9.287-1.621 2.806-1.079 5.198-2.626 7.18-4.644 1.977-2.012 3.524-4.389 4.641-7.124 1.114-2.735 1.674-5.794 1.674-9.177v-.217Zm14.468 14.9c-1.945 4.608-4.698 8.603-8.259 11.984-3.563 3.384-7.812 6.046-12.74 7.989-4.931 1.945-10.348 2.916-16.251 2.916H78.402V.965h29.475c5.903 0 11.32.954 16.251 2.86 4.928 1.908 9.177 4.554 12.74 7.936 3.561 3.384 6.314 7.361 8.259 11.93 1.943 4.573 2.916 9.522 2.916 14.847v.216c0 5.328-.973 10.295-2.916 14.9Z"
                    mask="url(#bE)"
                />
            </g>
            <path
                fill="#00ACB8"
                d="M70.175 114.259H57.672v6.999h11.186v2.108H57.672v7.174h12.65v2.108H55.358V112.15h14.817v2.109"
            />
            <g transform="translate(78 111)">
                <mask id="bG" fill="#fff">
                    <use xlink:href="#bF" />
                </mask>
                <path
                    fill="#00ACB8"
                    d="M15.8 8.237a7.644 7.644 0 0 0-1.699-2.591c-.732-.732-1.625-1.309-2.678-1.728-1.055-.42-2.226-.63-3.515-.63H3.106V19.51h4.802c1.289 0 2.46-.204 3.515-.614 1.053-.411 1.946-.981 2.678-1.713a7.732 7.732 0 0 0 1.699-2.562c.399-.977.601-2.04.601-3.192a8.5 8.5 0 0 0-.601-3.192Zm2.211 7.188a9.516 9.516 0 0 1-2.24 3.266c-.967.918-2.119 1.64-3.455 2.166-1.338.528-2.807.791-4.408.791H.793V1.15h7.115c1.601 0 3.07.259 4.408.776 1.336.518 2.488 1.236 3.455 2.153a9.561 9.561 0 0 1 2.24 3.251c.527 1.248.79 2.596.79 4.041 0 1.444-.263 2.796-.79 4.054Zm26.529-2.532c0 1.503-.205 2.821-.615 3.953-.409 1.133-.99 2.079-1.742 2.84a7.169 7.169 0 0 1-2.694 1.713c-1.044.381-2.21.572-3.499.572-1.27 0-2.425-.191-3.47-.572a7.273 7.273 0 0 1-2.694-1.698c-.752-.751-1.332-1.683-1.742-2.797-.41-1.113-.616-2.391-.616-3.835V1.15h2.314v11.771c0 2.227.552 3.936 1.655 5.125 1.102 1.191 2.639 1.786 4.612 1.786 1.893 0 3.397-.565 4.509-1.697 1.113-1.133 1.669-2.821 1.669-5.066V1.15h2.313v11.743m25.614 6.983a10.283 10.283 0 0 1-3.997 1.861c-.761.176-1.611.262-2.548.262-1.483 0-2.851-.272-4.099-.819a10.152 10.152 0 0 1-3.251-2.24 10.229 10.229 0 0 1-2.152-3.353c-.517-1.289-.776-2.675-.776-4.158 0-1.464.259-2.841.776-4.129a10.551 10.551 0 0 1 2.152-3.382 10.012 10.012 0 0 1 3.28-2.285c1.269-.555 2.655-.835 4.158-.835.937 0 1.782.079 2.533.235.751.157 1.45.376 2.094.659.644.283 1.24.625 1.786 1.025.546.401 1.073.845 1.581 1.333L70.11 5.748a12.92 12.92 0 0 0-2.826-2.021c-1.005-.526-2.211-.79-3.616-.79-1.133 0-2.181.215-3.148.644a7.701 7.701 0 0 0-2.519 1.786 8.283 8.283 0 0 0-1.668 2.679c-.401 1.026-.601 2.133-.601 3.325 0 1.191.2 2.303.601 3.336a8.256 8.256 0 0 0 1.668 2.696 7.876 7.876 0 0 0 2.519 1.8c.967.439 2.015.659 3.148.659 1.405 0 2.615-.259 3.631-.777 1.015-.515 2.01-1.243 2.986-2.181l1.523 1.494a14.606 14.606 0 0 1-1.654 1.478"
                    mask="url(#bG)"
                />
            </g>
            <path
                fill="#00ACB8"
                d="m166.741 114.727-4.684 10.454h9.341l-4.657-10.454Zm10.455 17.921h-2.49l-2.401-5.418h-11.156l-2.431 5.418h-2.372l9.342-20.644h2.167l9.341 20.644Zm13.001 0h-2.313v-18.36h-6.882v-2.138h16.076v2.138h-6.881v18.36"
            />
            <g transform="translate(205 111)">
                <mask id="bI" fill="#fff">
                    <use xlink:href="#bH" />
                </mask>
                <path
                    fill="#00ACB8"
                    d="M.353 21.648h2.314V1.15H.353zM29.79 8.119a8.138 8.138 0 0 0-1.683-2.694 8.182 8.182 0 0 0-2.562-1.814c-.986-.449-2.065-.674-3.236-.674-1.171 0-2.25.219-3.236.658a7.633 7.633 0 0 0-2.533 1.802 8.417 8.417 0 0 0-1.654 2.68 8.977 8.977 0 0 0-.601 3.294c0 1.17.201 2.273.601 3.308a8.104 8.104 0 0 0 1.684 2.694 8.132 8.132 0 0 0 2.562 1.816c.985.448 2.064.673 3.235.673 1.171 0 2.25-.22 3.236-.659a7.628 7.628 0 0 0 2.533-1.8 8.421 8.421 0 0 0 1.654-2.68 8.96 8.96 0 0 0 .601-3.294c0-1.171-.2-2.275-.601-3.31Zm2.241 7.306a10.59 10.59 0 0 1-2.138 3.383c-.918.977-2.021 1.752-3.309 2.328-1.288.574-2.714.863-4.275.863-1.562 0-2.982-.283-4.261-.849a10.155 10.155 0 0 1-3.294-2.299 10.206 10.206 0 0 1-2.123-3.367 11.066 11.066 0 0 1-.747-4.055c0-1.426.254-2.776.762-4.056a10.565 10.565 0 0 1 2.137-3.381c.918-.977 2.021-1.752 3.309-2.328 1.289-.577 2.713-.866 4.275-.866 1.562 0 2.982.285 4.261.85a10.174 10.174 0 0 1 3.295 2.299 10.229 10.229 0 0 1 2.122 3.367c.499 1.28.747 2.631.747 4.057 0 1.425-.254 2.776-.761 4.054Z"
                    mask="url(#bI)"
                />
            </g>
            <path
                fill="#00ACB8"
                d="M261.903 112.15h2.255v20.498h-1.845l-13.235-16.808v16.808h-2.255V112.15h2.167l12.913 16.429V112.15m37.565 3.21c-.919-.713-2.21-1.072-3.875-1.072h-6.34v8.345h6.311c.763 0 1.467-.096 2.113-.293a5.119 5.119 0 0 0 1.674-.838c.47-.363.836-.807 1.101-1.337.264-.529.396-1.126.396-1.792 0-1.292-.461-2.296-1.38-3.013Zm1.585 17.288-5.944-7.964h-5.856v7.964h-2.314V112.15h8.814c1.131 0 2.153.147 3.06.44.907.293 1.684.708 2.328 1.244a5.555 5.555 0 0 1 1.493 1.935c.352.752.528 1.587.528 2.505 0 .859-.137 1.626-.41 2.299a5.293 5.293 0 0 1-1.157 1.759 6.53 6.53 0 0 1-1.772 1.246 8.249 8.249 0 0 1-2.226.701l6.296 8.369h-2.84Z"
            />
            <g transform="translate(312 111)">
                <mask id="bK" fill="#fff">
                    <use xlink:href="#bJ" />
                </mask>
                <path
                    fill="#00ACB8"
                    d="M15.133 3.259H2.629v6.999h11.186v2.108H2.629v7.174h12.65v2.108H.315V1.15h14.818v2.109M26.121 7.57c.157.391.44.749.849 1.071.411.323.976.616 1.699.881.722.263 1.649.513 2.782.748 2.284.507 3.968 1.211 5.052 2.11 1.083.899 1.625 2.142 1.625 3.725 0 .88-.174 1.681-.521 2.404a5.466 5.466 0 0 1-1.435 1.849c-.61.508-1.344.899-2.203 1.173-.859.273-1.796.41-2.811.41-1.64 0-3.138-.265-4.495-.793-1.357-.529-2.651-1.349-3.88-2.457l1.435-1.698c1.073.976 2.157 1.703 3.25 2.181s2.353.717 3.778.717c1.386 0 2.493-.322 3.323-.967.83-.646 1.245-1.496 1.245-2.552 0-.489-.078-.923-.235-1.305-.156-.381-.431-.729-.821-1.041-.393-.314-.935-.597-1.63-.851-.695-.254-1.58-.498-2.657-.732-1.173-.255-2.196-.548-3.067-.881-.871-.332-1.59-.732-2.157-1.202a4.43 4.43 0 0 1-1.263-1.642c-.273-.626-.41-1.37-.41-2.229 0-.821.165-1.574.497-2.259a5.242 5.242 0 0 1 1.406-1.773 6.823 6.823 0 0 1 2.138-1.174C28.434 1 29.333.857 30.309.857c1.503 0 2.816.207 3.939.622 1.122.413 2.21 1.035 3.264 1.867l-1.346 1.787c-.957-.78-1.918-1.347-2.885-1.698a8.788 8.788 0 0 0-3.03-.527c-.664 0-1.265.089-1.801.264-.538.176-.996.41-1.377.703a3.017 3.017 0 0 0-.878 1.055 2.924 2.924 0 0 0-.308 1.32c0 .49.078.93.234 1.32m37.575.549a8.108 8.108 0 0 0-1.684-2.694 8.155 8.155 0 0 0-2.561-1.814c-.986-.449-2.065-.674-3.236-.674-1.171 0-2.249.219-3.236.658a7.643 7.643 0 0 0-2.533 1.802 8.417 8.417 0 0 0-1.654 2.68 8.956 8.956 0 0 0-.6 3.294c0 1.17.199 2.273.6 3.308a8.118 8.118 0 0 0 1.683 2.694 8.148 8.148 0 0 0 2.563 1.816c.985.448 2.064.673 3.235.673 1.172 0 2.25-.22 3.236-.659a7.617 7.617 0 0 0 2.533-1.8 8.404 8.404 0 0 0 1.654-2.68 8.98 8.98 0 0 0 .601-3.294 9.105 9.105 0 0 0-.601-3.31Zm2.241 7.306a10.604 10.604 0 0 1-2.137 3.383c-.918.977-2.022 1.752-3.31 2.328-1.288.574-2.714.863-4.275.863-1.562 0-2.982-.283-4.261-.849a10.155 10.155 0 0 1-3.294-2.299 10.188 10.188 0 0 1-2.122-3.367 11.046 11.046 0 0 1-.747-4.055c0-1.426.253-2.776.76-4.056a10.585 10.585 0 0 1 2.138-3.381c.918-.977 2.022-1.752 3.31-2.328 1.288-.577 2.713-.866 4.274-.866 1.562 0 2.983.285 4.262.85a10.18 10.18 0 0 1 3.294 2.299 10.229 10.229 0 0 1 2.122 3.367c.499 1.28.747 2.631.747 4.057 0 1.425-.253 2.776-.761 4.054Zm26.571-2.532c0 1.503-.207 2.821-.616 3.953-.409 1.133-.991 2.079-1.742 2.84a7.173 7.173 0 0 1-2.693 1.713c-1.046.381-2.212.572-3.5.572-1.27 0-2.426-.191-3.47-.572a7.265 7.265 0 0 1-2.694-1.698c-.752-.751-1.332-1.683-1.742-2.797-.411-1.113-.616-2.391-.616-3.835V1.15h2.314v11.771c0 2.227.552 3.936 1.655 5.125 1.102 1.191 2.639 1.786 4.611 1.786 1.894 0 3.397-.565 4.51-1.697 1.112-1.133 1.669-2.821 1.669-5.066V1.15h2.314v11.743M114.92 4.36c-.92-.713-2.212-1.072-3.875-1.072h-6.341v8.345h6.311c.763 0 1.467-.096 2.114-.293a5.123 5.123 0 0 0 1.673-.838c.47-.363.836-.807 1.101-1.337.264-.529.397-1.126.397-1.792 0-1.292-.461-2.296-1.38-3.013Zm1.585 17.288-5.945-7.964h-5.856v7.964h-2.314V1.15h8.814c1.132 0 2.152.147 3.059.44.909.293 1.685.708 2.329 1.244a5.581 5.581 0 0 1 1.494 1.935c.35.752.527 1.587.527 2.505 0 .859-.137 1.626-.411 2.299a5.273 5.273 0 0 1-1.155 1.759 6.55 6.55 0 0 1-1.773 1.246 8.242 8.242 0 0 1-2.225.701l6.295 8.369h-2.839Zm26.769-1.772a10.283 10.283 0 0 1-3.997 1.861c-.762.176-1.611.262-2.548.262-1.483 0-2.85-.272-4.099-.819a10.163 10.163 0 0 1-3.251-2.24 10.229 10.229 0 0 1-2.152-3.353c-.517-1.289-.776-2.675-.776-4.158 0-1.464.259-2.841.776-4.129a10.551 10.551 0 0 1 2.152-3.382 10.022 10.022 0 0 1 3.28-2.285c1.268-.555 2.654-.835 4.158-.835.937 0 1.781.079 2.532.235a10.56 10.56 0 0 1 2.095.659 9.426 9.426 0 0 1 1.785 1.025c.547.401 1.074.845 1.582 1.333l-1.582 1.698a12.938 12.938 0 0 0-2.825-2.021c-1.006-.526-2.211-.79-3.616-.79-1.133 0-2.182.215-3.149.644a7.718 7.718 0 0 0-2.518 1.786 8.266 8.266 0 0 0-1.668 2.679c-.401 1.026-.601 2.133-.601 3.325 0 1.191.2 2.303.601 3.336a8.24 8.24 0 0 0 1.668 2.696 7.894 7.894 0 0 0 2.518 1.8c.967.439 2.016.659 3.149.659 1.405 0 2.615-.259 3.631-.777 1.014-.515 2.009-1.243 2.986-2.181l1.523 1.494a14.692 14.692 0 0 1-1.654 1.478m24.652-16.617h-12.503v6.999h11.186v2.108h-11.186v7.174h12.65v2.108h-14.964V1.15h14.817v2.109m10.99 4.311c.157.391.44.749.849 1.071.411.323.976.616 1.699.881.722.263 1.649.513 2.782.748 2.284.507 3.968 1.211 5.052 2.11 1.083.899 1.625 2.142 1.625 3.725 0 .88-.174 1.681-.521 2.404a5.466 5.466 0 0 1-1.435 1.849c-.61.508-1.344.899-2.203 1.173-.859.273-1.797.41-2.811.41-1.64 0-3.138-.265-4.495-.793-1.357-.529-2.65-1.349-3.88-2.457l1.435-1.698c1.073.976 2.157 1.703 3.25 2.181s2.353.717 3.778.717c1.385 0 2.493-.322 3.323-.967.83-.646 1.245-1.496 1.245-2.552 0-.489-.078-.923-.234-1.305-.158-.381-.432-.729-.823-1.041-.391-.314-.934-.597-1.629-.851s-1.581-.498-2.657-.732c-1.174-.255-2.196-.548-3.067-.881-.871-.332-1.59-.732-2.157-1.202a4.419 4.419 0 0 1-1.263-1.642c-.273-.626-.41-1.37-.41-2.229 0-.821.165-1.574.498-2.259.331-.684.8-1.275 1.405-1.773a6.823 6.823 0 0 1 2.138-1.174c.819-.283 1.718-.426 2.694-.426 1.503 0 2.816.207 3.939.622 1.122.413 2.21 1.035 3.264 1.867l-1.346 1.787c-.957-.78-1.918-1.347-2.885-1.698a8.788 8.788 0 0 0-3.03-.527c-.664 0-1.265.089-1.801.264-.538.176-.996.41-1.377.703a3.017 3.017 0 0 0-.878 1.055 2.924 2.924 0 0 0-.308 1.32c0 .49.077.93.234 1.32"
                    mask="url(#bK)"
                />
            </g>
            <g transform="translate(80 8)">
                <mask id="bN" fill="#fff">
                    <use xlink:href="#bL" />
                </mask>
                <path
                    fill="url(#bM)"
                    d="M2.545 5.375a2.732 2.732 0 0 0 2.732-2.732c0-.661-.244-1.259-.635-1.732A43.117 43.117 0 0 0 .308 4.205a2.725 2.725 0 0 0 2.237 1.17"
                    mask="url(#bN)"
                />
            </g>
            <g transform="translate(86 7)">
                <mask id="bQ" fill="#fff">
                    <use xlink:href="#bO" />
                </mask>
                <path
                    fill="url(#bP)"
                    d="M3.07.785a2.858 2.858 0 1 0-.002 5.716A2.858 2.858 0 0 0 3.07.785"
                    mask="url(#bQ)"
                />
            </g>
            <g transform="translate(92 7)">
                <mask id="bT" fill="#fff">
                    <use xlink:href="#bR" />
                </mask>
                <path
                    fill="url(#bS)"
                    d="M3.595 6.592a2.949 2.949 0 1 0 0-5.897 2.949 2.949 0 0 0 0 5.897"
                    mask="url(#bT)"
                />
            </g>
            <g transform="translate(99 7)">
                <mask id="bW" fill="#fff">
                    <use xlink:href="#bU" />
                </mask>
                <path
                    fill="url(#bV)"
                    d="M3.12 6.683a3.04 3.04 0 1 0 0-6.08 3.04 3.04 0 0 0 0 6.08"
                    mask="url(#bW)"
                />
            </g>
            <g transform="translate(105 7)">
                <mask id="bZ" fill="#fff">
                    <use xlink:href="#bX" />
                </mask>
                <path
                    fill="url(#bY)"
                    d="M3.645 6.755a3.112 3.112 0 1 0 0-6.223 3.112 3.112 0 0 0 0 6.223"
                    mask="url(#bZ)"
                />
            </g>
            <g transform="translate(111 7)">
                <mask id="cc" fill="#fff">
                    <use xlink:href="#ca" />
                </mask>
                <path
                    fill="url(#cb)"
                    d="M3.551.503a3.201 3.201 0 0 0 .619 6.343A3.203 3.203 0 0 0 4.789.503a3.51 3.51 0 0 1-.619.062 3.51 3.51 0 0 1-.619-.062"
                    mask="url(#cc)"
                />
            </g>
            <g transform="translate(118 7)">
                <mask id="cf" fill="#fff">
                    <use xlink:href="#cd" />
                </mask>
                <path
                    fill="url(#ce)"
                    d="M6.922 3.34A3.239 3.239 0 0 0 4.545.513a3.562 3.562 0 0 1-.85.112c-.294 0-.576-.045-.85-.112a3.247 3.247 0 0 0-2.407 3.13A3.257 3.257 0 0 0 3.695 6.9c1.695 0 3.071-1.3 3.227-2.954-.01-.101-.031-.199-.031-.303 0-.103.021-.202.031-.303"
                    mask="url(#cf)"
                />
            </g>
            <g transform="translate(124 7)">
                <mask id="ci" fill="#fff">
                    <use xlink:href="#cg" />
                </mask>
                <path
                    fill="url(#ch)"
                    d="M4.883 6.906a3.33 3.33 0 0 0 2.581-2.534 3.304 3.304 0 0 1-.084-.729c0-.25.031-.493.084-.728A3.319 3.319 0 0 0 5.325.517 3.643 3.643 0 0 1 4.22.705c-.388 0-.754-.077-1.105-.188A3.307 3.307 0 0 0 .922 3.34c.009.101.03.2.03.303 0 .104-.021.202-.03.303a3.317 3.317 0 0 0 2.636 2.96 3.281 3.281 0 0 1 1.325 0"
                    mask="url(#ci)"
                />
            </g>
            <g transform="translate(124 10)">
                <mask id="b" fill="#fff">
                    <use xlink:href="#aA" />
                </mask>
                <use xlink:href="#cj" mask="url(#b)" />
            </g>
            <g transform="translate(124 10)">
                <mask id="cl" fill="#fff">
                    <use xlink:href="#ck" />
                </mask>
                <use xlink:href="#cj" mask="url(#cl)" />
            </g>
            <g transform="translate(131 7)">
                <mask id="co" fill="#fff">
                    <use xlink:href="#cm" />
                </mask>
                <path
                    fill="url(#cn)"
                    d="M2.512.519A3.36 3.36 0 0 0 .464 2.915c.052.234.085.477.085.728s-.033.494-.085.729a3.362 3.362 0 0 0 2.492 2.534c.254-.062.516-.103.789-.103s.535.041.789.103a3.354 3.354 0 0 0 2.454-2.412 3.414 3.414 0 0 1-.12-.851c0-.295.05-.577.12-.85A3.355 3.355 0 0 0 4.978.519a3.679 3.679 0 0 1-1.233.226C3.311.745 2.9.656 2.512.519"
                    mask="url(#co)"
                />
            </g>
            <g transform="translate(130 9)">
                <mask id="d" fill="#fff">
                    <use xlink:href="#aB" />
                </mask>
                <use xlink:href="#cp" mask="url(#d)" />
            </g>
            <g transform="translate(130 9)">
                <mask id="cr" fill="#fff">
                    <use xlink:href="#cq" />
                </mask>
                <use xlink:href="#cp" mask="url(#cr)" />
            </g>
            <g transform="translate(137 8)">
                <mask id="cu" fill="#fff">
                    <use xlink:href="#cs" />
                </mask>
                <path
                    fill="url(#ct)"
                    d="M.988 3.494a3.392 3.392 0 0 0 2.371 2.412c.292-.082.593-.139.911-.139.318 0 .619.057.911.139A3.39 3.39 0 0 0 7.332 4.1 43.235 43.235 0 0 0 1.955.164a3.38 3.38 0 0 0-.967 1.629c.072.273.123.555.123.85 0 .296-.051.577-.123.851"
                    mask="url(#cu)"
                />
            </g>
            <g transform="translate(137 9)">
                <mask id="f" fill="#fff">
                    <use xlink:href="#aC" />
                </mask>
                <use xlink:href="#cv" mask="url(#f)" />
            </g>
            <g transform="translate(137 9)">
                <mask id="cx" fill="#fff">
                    <use xlink:href="#cw" />
                </mask>
                <use xlink:href="#cv" mask="url(#cx)" />
            </g>
            <g transform="translate(87 4)">
                <mask id="cA" fill="#fff">
                    <use xlink:href="#cy" />
                </mask>
                <path
                    fill="url(#cz)"
                    d="M.652 3.079c.41.196.864.315 1.349.315A3.143 3.143 0 0 0 5.07.922 45.944 45.944 0 0 0 .652 3.079"
                    mask="url(#cA)"
                />
            </g>
            <g transform="translate(92 2)">
                <mask id="cD" fill="#fff">
                    <use xlink:href="#cB" />
                </mask>
                <path
                    fill="url(#cC)"
                    d="M6.808 1.73A3.22 3.22 0 0 0 6.547.711 48.768 48.768 0 0 0 .441 2.774a3.24 3.24 0 0 0 3.154 2.513 3.233 3.233 0 0 0 3.213-2.933c-.01-.104-.031-.205-.031-.312 0-.106.021-.207.031-.312"
                    mask="url(#cD)"
                />
            </g>
            <g transform="translate(98 1)">
                <mask id="cG" fill="#fff">
                    <use xlink:href="#cE" />
                </mask>
                <path
                    fill="url(#cF)"
                    d="M7.341 2.192A3.32 3.32 0 0 0 6.315.539a51.82 51.82 0 0 0-5.181 1.028A3.301 3.301 0 0 0 .808 2.73c.01.105.031.206.031.312 0 .107-.021.208-.031.312A3.331 3.331 0 0 0 4.12 6.386a3.335 3.335 0 0 0 3.221-2.493 3.407 3.407 0 0 1-.119-.851c0-.294.049-.576.119-.85"
                    mask="url(#cG)"
                />
            </g>
            <g transform="translate(98 3)">
                <mask id="h" fill="#fff">
                    <use xlink:href="#aD" />
                </mask>
                <use xlink:href="#cH" mask="url(#h)" />
            </g>
            <g transform="translate(98 3)">
                <mask id="cJ" fill="#fff">
                    <use xlink:href="#cI" />
                </mask>
                <use xlink:href="#cH" mask="url(#cJ)" />
            </g>
            <g transform="translate(105)">
                <mask id="cM" fill="#fff">
                    <use xlink:href="#cK" />
                </mask>
                <path
                    fill="url(#cL)"
                    d="M6.856 2.892A3.412 3.412 0 0 0 5.171.994a54.526 54.526 0 0 0-3.489.251A3.418 3.418 0 0 0 .341 3.192c.072.273.123.555.123.85 0 .296-.051.578-.123.851a3.416 3.416 0 0 0 3.304 2.573 3.414 3.414 0 0 0 3.211-2.272 3.495 3.495 0 0 1-.209-1.152c0-.405.083-.788.209-1.15"
                    mask="url(#cM)"
                />
            </g>
            <g transform="translate(104 3)">
                <mask id="j" fill="#fff">
                    <use xlink:href="#aE" />
                </mask>
                <use xlink:href="#cN" mask="url(#j)" />
            </g>
            <g transform="translate(104 3)">
                <mask id="cP" fill="#fff">
                    <use xlink:href="#cO" />
                </mask>
                <use xlink:href="#cN" mask="url(#cP)" />
            </g>
            <g transform="translate(111)">
                <mask id="cS" fill="#fff">
                    <use xlink:href="#cQ" />
                </mask>
                <path
                    fill="url(#cR)"
                    d="M7.399 2.64a3.53 3.53 0 0 0-1.225-1.49A56.083 56.083 0 0 0 2.48.97 3.505 3.505 0 0 0 .856 2.892c.13.361.213.745.213 1.15 0 .407-.083.79-.213 1.152a3.511 3.511 0 0 0 2.695 2.309 3.24 3.24 0 0 1 .619-.062c.212 0 .418.023.619.062a3.52 3.52 0 0 0 2.61-2.057 3.565 3.565 0 0 1-.286-1.404c0-.498.102-.972.286-1.402"
                    mask="url(#cS)"
                />
            </g>
            <g transform="translate(114 7)">
                <mask id="l" fill="#fff">
                    <use xlink:href="#aF" />
                </mask>
                <use xlink:href="#cT" mask="url(#l)" />
            </g>
            <g transform="translate(114 7)">
                <mask id="cV" fill="#fff">
                    <use xlink:href="#cU" />
                </mask>
                <use xlink:href="#cT" mask="url(#cV)" />
            </g>
            <g transform="translate(111 2)">
                <mask id="n" fill="#fff">
                    <use xlink:href="#aG" />
                </mask>
                <use xlink:href="#cW" mask="url(#n)" />
            </g>
            <g transform="translate(111 2)">
                <mask id="cY" fill="#fff">
                    <use xlink:href="#cX" />
                </mask>
                <use xlink:href="#cW" mask="url(#cY)" />
            </g>
            <g transform="translate(118 1)">
                <mask id="db" fill="#fff">
                    <use xlink:href="#cZ" />
                </mask>
                <path
                    fill="url(#da)"
                    d="M4.545 6.513a3.576 3.576 0 0 0 2.367-1.922 3.637 3.637 0 0 1-.354-1.549c0-.555.133-1.076.354-1.548-.019-.04-.043-.078-.064-.118A52.41 52.41 0 0 0 1.32.379 3.572 3.572 0 0 0 .399 1.64a3.505 3.505 0 0 1 0 2.806 3.582 3.582 0 0 0 2.446 2.067c.273-.075.554-.126.85-.126.296 0 .578.051.85.126"
                    mask="url(#db)"
                />
            </g>
            <g transform="translate(120 7)">
                <mask id="p" fill="#fff">
                    <use xlink:href="#aH" />
                </mask>
                <use xlink:href="#dc" mask="url(#p)" />
            </g>
            <g transform="translate(120 7)">
                <mask id="de" fill="#fff">
                    <use xlink:href="#dd" />
                </mask>
                <use xlink:href="#dc" mask="url(#de)" />
            </g>
            <g transform="translate(117 2)">
                <mask id="r" fill="#fff">
                    <use xlink:href="#aI" />
                </mask>
                <use xlink:href="#df" mask="url(#r)" />
            </g>
            <g transform="translate(117 2)">
                <mask id="dh" fill="#fff">
                    <use xlink:href="#dg" />
                </mask>
                <use xlink:href="#df" mask="url(#dh)" />
            </g>
            <g transform="translate(124 2)">
                <mask id="dk" fill="#fff">
                    <use xlink:href="#di" />
                </mask>
                <path
                    fill="url(#dj)"
                    d="M.912 3.591a3.656 3.656 0 0 0 2.203 1.926 3.3 3.3 0 0 1 1.105-.203c.39 0 .758.08 1.105.203A3.648 3.648 0 0 0 7.46 3.716a3.652 3.652 0 0 1-.393-1.442A49.47 49.47 0 0 0 .962.404C.946.435.927.463.912.494c.227.47.366.991.366 1.548 0 .558-.139 1.079-.366 1.549"
                    mask="url(#dk)"
                />
            </g>
            <g transform="translate(127 7)">
                <mask id="t" fill="#fff">
                    <use xlink:href="#aJ" />
                </mask>
                <use xlink:href="#dl" mask="url(#t)" />
            </g>
            <g transform="translate(127 7)">
                <mask id="dn" fill="#fff">
                    <use xlink:href="#dm" />
                </mask>
                <use xlink:href="#dl" mask="url(#dn)" />
            </g>
            <g transform="translate(124 2)">
                <mask id="v" fill="#fff">
                    <use xlink:href="#aK" />
                </mask>
                <use xlink:href="#do" mask="url(#v)" />
            </g>
            <g transform="translate(124 2)">
                <mask id="dq" fill="#fff">
                    <use xlink:href="#dp" />
                </mask>
                <use xlink:href="#do" mask="url(#dq)" />
            </g>
            <g transform="translate(131 4)">
                <mask id="dt" fill="#fff">
                    <use xlink:href="#dr" />
                </mask>
                <path
                    fill="url(#ds)"
                    d="M2.512 3.519a3.331 3.331 0 0 1 1.233-.241c.436 0 .85.089 1.233.241.356-.127.685-.303.981-.525A46.231 46.231 0 0 0 .828.578 3.61 3.61 0 0 1 .46 1.716a3.69 3.69 0 0 0 2.052 1.803"
                    mask="url(#dt)"
                />
            </g>
            <g transform="translate(133 7)">
                <mask id="x" fill="#fff">
                    <use xlink:href="#aL" />
                </mask>
                <use xlink:href="#du" mask="url(#x)" />
            </g>
            <g transform="translate(133 7)">
                <mask id="dw" fill="#fff">
                    <use xlink:href="#dv" />
                </mask>
                <use xlink:href="#du" mask="url(#dw)" />
            </g>
            <g transform="translate(130 4)">
                <mask id="z" fill="#fff">
                    <use xlink:href="#aM" />
                </mask>
                <use xlink:href="#dx" mask="url(#z)" />
            </g>
            <g transform="translate(130 4)">
                <mask id="dz" fill="#fff">
                    <use xlink:href="#dy" />
                </mask>
                <use xlink:href="#dx" mask="url(#dz)" />
            </g>
            <g transform="translate(74 14)">
                <mask id="dC" fill="#fff">
                    <use xlink:href="#dA" />
                </mask>
                <path
                    fill="url(#dB)"
                    d="M2.02 5.792a2.624 2.624 0 0 0 2.624-2.624c0-.935-.493-1.75-1.23-2.214A41.317 41.317 0 0 0 .08 4.92c.48.532 1.168.872 1.94.872"
                    mask="url(#dC)"
                />
            </g>
            <g transform="translate(79 14)">
                <mask id="dF" fill="#fff">
                    <use xlink:href="#dD" />
                </mask>
                <path
                    fill="url(#dE)"
                    d="M3.545.436a2.732 2.732 0 1 0 0 5.464 2.732 2.732 0 0 0 0-5.464"
                    mask="url(#dF)"
                />
            </g>
            <g transform="translate(86 14)">
                <mask id="dI" fill="#fff">
                    <use xlink:href="#dG" />
                </mask>
                <path
                    fill="url(#dH)"
                    d="M3.07.309a2.859 2.859 0 1 0 0 5.718 2.859 2.859 0 0 0 0-5.718"
                    mask="url(#dI)"
                />
            </g>
            <g transform="translate(92 14)">
                <mask id="dL" fill="#fff">
                    <use xlink:href="#dJ" />
                </mask>
                <path
                    fill="url(#dK)"
                    d="M3.595 6.118a2.95 2.95 0 1 0 0-5.899 2.95 2.95 0 0 0 0 5.899"
                    mask="url(#dL)"
                />
            </g>
            <g transform="translate(99 14)">
                <mask id="dO" fill="#fff">
                    <use xlink:href="#dM" />
                </mask>
                <path
                    fill="url(#dN)"
                    d="M3.12 6.208a3.04 3.04 0 1 0 0-6.08 3.04 3.04 0 0 0 0 6.08"
                    mask="url(#dO)"
                />
            </g>
            <g transform="translate(105 14)">
                <mask id="dR" fill="#fff">
                    <use xlink:href="#dP" />
                </mask>
                <path
                    fill="url(#dQ)"
                    d="M3.645 6.28a3.112 3.112 0 1 0 0-6.223 3.112 3.112 0 0 0 0 6.223"
                    mask="url(#dR)"
                />
            </g>
            <g transform="translate(111 13)">
                <mask id="dU" fill="#fff">
                    <use xlink:href="#dS" />
                </mask>
                <path
                    fill="url(#dT)"
                    d="M7.373 4.168A3.202 3.202 0 0 0 4.17.966a3.202 3.202 0 1 0 0 6.405 3.203 3.203 0 0 0 3.203-3.203"
                    mask="url(#dU)"
                />
            </g>
            <g transform="translate(118 13)">
                <mask id="dX" fill="#fff">
                    <use xlink:href="#dV" />
                </mask>
                <path
                    fill="url(#dW)"
                    d="M6.922 3.865A3.247 3.247 0 0 0 3.695.912a3.257 3.257 0 1 0 0 6.513c1.695 0 3.071-1.3 3.227-2.954-.01-.101-.031-.199-.031-.303 0-.104.021-.202.031-.303"
                    mask="url(#dX)"
                />
            </g>
            <g transform="translate(124 13)">
                <mask id="ea" fill="#fff">
                    <use xlink:href="#dY" />
                </mask>
                <path
                    fill="url(#dZ)"
                    d="M4.523 7.467a3.317 3.317 0 0 0 2.941-2.57 3.304 3.304 0 0 1-.084-.729c0-.251.031-.493.084-.729A3.33 3.33 0 0 0 4.883.906a3.355 3.355 0 0 1-1.325 0A3.317 3.317 0 0 0 .922 3.865c.009.101.03.199.03.303 0 .104-.021.202-.03.303a3.307 3.307 0 0 0 2.995 2.996c.101-.01.199-.031.303-.031.104 0 .202.021.303.031"
                    mask="url(#ea)"
                />
            </g>
            <g transform="translate(127 13)">
                <mask id="B" fill="#fff">
                    <use xlink:href="#aN" />
                </mask>
                <use xlink:href="#eb" mask="url(#B)" />
            </g>
            <g transform="translate(127 13)">
                <mask id="ed" fill="#fff">
                    <use xlink:href="#ec" />
                </mask>
                <use xlink:href="#eb" mask="url(#ed)" />
            </g>
            <g transform="translate(124 16)">
                <mask id="D" fill="#fff">
                    <use xlink:href="#aO" />
                </mask>
                <use xlink:href="#ee" mask="url(#D)" />
            </g>
            <g transform="translate(124 16)">
                <mask id="eg" fill="#fff">
                    <use xlink:href="#ef" />
                </mask>
                <use xlink:href="#ee" mask="url(#eg)" />
            </g>
            <g transform="translate(131 13)">
                <mask id="ej" fill="#fff">
                    <use xlink:href="#eh" />
                </mask>
                <path
                    fill="url(#ei)"
                    d="M6.988 5.018a3.4 3.4 0 0 1-.12-.85c0-.295.05-.577.12-.85A3.352 3.352 0 0 0 4.534.906a3.364 3.364 0 0 1-.789.103c-.273 0-.535-.042-.789-.103A3.359 3.359 0 0 0 .464 3.439c.052.236.085.478.085.729s-.033.494-.085.729A3.363 3.363 0 0 0 3.016 7.45c.235-.053.478-.086.729-.086s.493.033.729.086a3.358 3.358 0 0 0 2.514-2.432"
                    mask="url(#ej)"
                />
            </g>
            <g transform="translate(133 13)">
                <mask id="F" fill="#fff">
                    <use xlink:href="#aP" />
                </mask>
                <use xlink:href="#ek" mask="url(#F)" />
            </g>
            <g transform="translate(133 13)">
                <mask id="em" fill="#fff">
                    <use xlink:href="#el" />
                </mask>
                <use xlink:href="#ek" mask="url(#em)" />
            </g>
            <g transform="translate(130 16)">
                <mask id="H" fill="#fff">
                    <use xlink:href="#aQ" />
                </mask>
                <use xlink:href="#en" mask="url(#H)" />
            </g>
            <g transform="translate(130 16)">
                <mask id="ep" fill="#fff">
                    <use xlink:href="#eo" />
                </mask>
                <use xlink:href="#en" mask="url(#ep)" />
            </g>
            <g transform="translate(137 13)">
                <mask id="es" fill="#fff">
                    <use xlink:href="#eq" />
                </mask>
                <path
                    fill="url(#er)"
                    d="M3.359.906A3.389 3.389 0 0 0 .988 3.318c.072.273.123.554.123.85 0 .296-.051.577-.123.85A3.392 3.392 0 0 0 3.42 7.45c.273-.072.554-.122.85-.122.296 0 .577.05.85.122a3.389 3.389 0 0 0 2.377-2.256 3.704 3.704 0 0 1-.16-1.026c0-.358.066-.698.16-1.026A3.386 3.386 0 0 0 5.181.906a3.386 3.386 0 0 1-.911.139c-.318 0-.619-.058-.911-.139"
                    mask="url(#es)"
                />
            </g>
            <g transform="translate(140 13)">
                <mask id="J" fill="#fff">
                    <use xlink:href="#aR" />
                </mask>
                <use xlink:href="#et" mask="url(#J)" />
            </g>
            <g transform="translate(140 13)">
                <mask id="ev" fill="#fff">
                    <use xlink:href="#eu" />
                </mask>
                <use xlink:href="#et" mask="url(#ev)" />
            </g>
            <g transform="translate(137 16)">
                <mask id="L" fill="#fff">
                    <use xlink:href="#aS" />
                </mask>
                <use xlink:href="#ew" mask="url(#L)" />
            </g>
            <g transform="translate(137 16)">
                <mask id="ey" fill="#fff">
                    <use xlink:href="#ex" />
                </mask>
                <use xlink:href="#ew" mask="url(#ey)" />
            </g>
            <g transform="translate(69 22)">
                <mask id="eB" fill="#fff">
                    <use xlink:href="#ez" />
                </mask>
                <path
                    fill="url(#eA)"
                    d="M1.013 4.045a2.352 2.352 0 0 0 2.352-2.352A2.33 2.33 0 0 0 2.861.254 41 41 0 0 0 .863 4.03c.05.004.099.015.15.015"
                    mask="url(#eB)"
                />
            </g>
            <g transform="translate(73 21)">
                <mask id="eE" fill="#fff">
                    <use xlink:href="#eC" />
                </mask>
                <path
                    fill="url(#eD)"
                    d="M3.02.196a2.497 2.497 0 1 0 0 4.994 2.497 2.497 0 0 0 0-4.994"
                    mask="url(#eE)"
                />
            </g>
            <g transform="translate(79 21)">
                <mask id="eH" fill="#fff">
                    <use xlink:href="#eF" />
                </mask>
                <path
                    fill="url(#eG)"
                    d="M3.545.07a2.623 2.623 0 1 0 0 5.247 2.624 2.624 0 0 0 0-5.247"
                    mask="url(#eH)"
                />
            </g>
            <g transform="translate(86 20)">
                <mask id="eK" fill="#fff">
                    <use xlink:href="#eI" />
                </mask>
                <path
                    fill="url(#eJ)"
                    d="M3.07.961a2.732 2.732 0 1 0 0 5.464 2.732 2.732 0 0 0 0-5.464"
                    mask="url(#eK)"
                />
            </g>
            <g transform="translate(92 20)">
                <mask id="eN" fill="#fff">
                    <use xlink:href="#eL" />
                </mask>
                <path
                    fill="url(#eM)"
                    d="M6.454 3.693a2.859 2.859 0 1 0-5.718 0 2.859 2.859 0 0 0 5.718 0"
                    mask="url(#eN)"
                />
            </g>
            <g transform="translate(99 20)">
                <mask id="eQ" fill="#fff">
                    <use xlink:href="#eO" />
                </mask>
                <path
                    fill="url(#eP)"
                    d="M3.12.744A2.949 2.949 0 0 0 .171 3.693a2.946 2.946 0 0 0 2.395 2.893 19.106 19.106 0 0 1 3.165-1.548c.209-.405.338-.857.338-1.345A2.949 2.949 0 0 0 3.12.744"
                    mask="url(#eQ)"
                />
            </g>
            <g transform="translate(105 20)">
                <mask id="eT" fill="#fff">
                    <use xlink:href="#eR" />
                </mask>
                <path
                    fill="url(#eS)"
                    d="M3.645.653a3.04 3.04 0 0 0-3.04 3.04c0 .338.069.657.17.961 1.824-.579 3.805-.901 5.91-.962A3.041 3.041 0 0 0 3.645.653"
                    mask="url(#eT)"
                />
            </g>
            <g transform="translate(112 20)">
                <mask id="eW" fill="#fff">
                    <use xlink:href="#eU" />
                </mask>
                <path
                    fill="url(#eV)"
                    d="M6.183 4.436c.059-.239.099-.485.099-.743A3.112 3.112 0 0 0 .06 3.674c.108-.002.21-.016.319-.016 2.066 0 3.997.285 5.804.778"
                    mask="url(#eW)"
                />
            </g>
            <g transform="translate(118 20)">
                <mask id="eZ" fill="#fff">
                    <use xlink:href="#eX" />
                </mask>
                <path
                    fill="url(#eY)"
                    d="M6.898 3.693A3.202 3.202 0 0 0 3.695.491 3.202 3.202 0 0 0 .492 3.693c0 .298.054.581.13.855a19.266 19.266 0 0 1 4.504 1.996 3.191 3.191 0 0 0 1.772-2.851"
                    mask="url(#eZ)"
                />
            </g>
            <g transform="translate(124 20)">
                <mask id="fc" fill="#fff">
                    <use xlink:href="#fa" />
                </mask>
                <path
                    fill="url(#fb)"
                    d="M7.446 3.39A3.234 3.234 0 0 0 4.523.467c-.101.009-.199.03-.303.03-.104 0-.202-.021-.303-.03A3.246 3.246 0 0 0 .963 3.693 3.257 3.257 0 0 0 4.22 6.95a3.245 3.245 0 0 0 3.226-2.954c-.009-.101-.03-.199-.03-.303 0-.104.021-.201.03-.303"
                    mask="url(#fc)"
                />
            </g>
            <g transform="translate(127 19)">
                <mask id="N" fill="#fff">
                    <use xlink:href="#aT" />
                </mask>
                <use xlink:href="#fd" mask="url(#N)" />
            </g>
            <g transform="translate(127 19)">
                <mask id="ff" fill="#fff">
                    <use xlink:href="#fe" />
                </mask>
                <use xlink:href="#fd" mask="url(#ff)" />
            </g>
            <g transform="translate(131 20)">
                <mask id="fi" fill="#fff">
                    <use xlink:href="#fg" />
                </mask>
                <path
                    fill="url(#fh)"
                    d="M4.048 6.992a3.316 3.316 0 0 0 2.94-2.57 3.429 3.429 0 0 1-.084-.729c0-.251.033-.493.084-.729A3.323 3.323 0 0 0 4.474.45a3.436 3.436 0 0 1-.729.084c-.251 0-.493-.032-.729-.084a3.316 3.316 0 0 0-2.57 2.94c.01.102.031.199.031.303 0 .104-.021.202-.031.303a3.308 3.308 0 0 0 2.996 2.996c.101-.01.199-.031.303-.031.104 0 .202.021.303.031"
                    mask="url(#fi)"
                />
            </g>
            <g transform="translate(134 19)">
                <mask id="P" fill="#fff">
                    <use xlink:href="#aU" />
                </mask>
                <use xlink:href="#fj" mask="url(#P)" />
            </g>
            <g transform="translate(134 19)">
                <mask id="fl" fill="#fff">
                    <use xlink:href="#fk" />
                </mask>
                <use xlink:href="#fj" mask="url(#fl)" />
            </g>
            <g transform="translate(130 23)">
                <mask id="R" fill="#fff">
                    <use xlink:href="#aV" />
                </mask>
                <use xlink:href="#fm" mask="url(#R)" />
            </g>
            <g transform="translate(130 23)">
                <mask id="fo" fill="#fff">
                    <use xlink:href="#fn" />
                </mask>
                <use xlink:href="#fm" mask="url(#fo)" />
            </g>
            <g transform="translate(137 20)">
                <mask id="fr" fill="#fff">
                    <use xlink:href="#fp" />
                </mask>
                <path
                    fill="url(#fq)"
                    d="M7.499 4.592a3.651 3.651 0 0 1-.123-.899c0-.311.05-.609.123-.898A3.352 3.352 0 0 0 5.12.45a3.4 3.4 0 0 1-.85.12c-.295 0-.577-.05-.85-.12A3.358 3.358 0 0 0 .988 2.964c.053.236.086.478.086.729s-.033.494-.086.729a3.366 3.366 0 0 0 2.553 2.553c.235-.053.478-.086.729-.086s.494.033.729.086a3.357 3.357 0 0 0 2.5-2.383"
                    mask="url(#fr)"
                />
            </g>
            <g transform="translate(140 19)">
                <mask id="T" fill="#fff">
                    <use xlink:href="#aW" />
                </mask>
                <use xlink:href="#fs" mask="url(#T)" />
            </g>
            <g transform="translate(140 19)">
                <mask id="fu" fill="#fff">
                    <use xlink:href="#ft" />
                </mask>
                <use xlink:href="#fs" mask="url(#fu)" />
            </g>
            <g transform="translate(137 22)">
                <mask id="V" fill="#fff">
                    <use xlink:href="#aX" />
                </mask>
                <use xlink:href="#fv" mask="url(#V)" />
            </g>
            <g transform="translate(137 22)">
                <mask id="fx" fill="#fff">
                    <use xlink:href="#fw" />
                </mask>
                <use xlink:href="#fv" mask="url(#fx)" />
            </g>
            <g transform="translate(67 28)">
                <mask id="fA" fill="#fff">
                    <use xlink:href="#fy" />
                </mask>
                <path
                    fill="url(#fz)"
                    d="M2.495 4.426a2.208 2.208 0 0 0 0-4.415c-.179 0-.351.027-.518.068A42.24 42.24 0 0 0 .75 3.555a2.194 2.194 0 0 0 1.745.871"
                    mask="url(#fA)"
                />
            </g>
            <g transform="translate(73 27)">
                <mask id="fD" fill="#fff">
                    <use xlink:href="#fB" />
                </mask>
                <path
                    fill="url(#fC)"
                    d="M3.02.866a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704"
                    mask="url(#fD)"
                />
            </g>
            <g transform="translate(80 27)">
                <mask id="fG" fill="#fff">
                    <use xlink:href="#fE" />
                </mask>
                <path
                    fill="url(#fF)"
                    d="M2.545.721a2.497 2.497 0 1 0 0 4.994 2.497 2.497 0 0 0 0-4.994"
                    mask="url(#fG)"
                />
            </g>
            <g transform="translate(86 27)">
                <mask id="fJ" fill="#fff">
                    <use xlink:href="#fH" />
                </mask>
                <path
                    fill="url(#fI)"
                    d="M3.07.595a2.623 2.623 0 1 0 0 5.247 2.624 2.624 0 0 0 0-5.247"
                    mask="url(#fJ)"
                />
            </g>
            <g transform="translate(92 27)">
                <mask id="fM" fill="#fff">
                    <use xlink:href="#fK" />
                </mask>
                <path
                    fill="url(#fL)"
                    d="M3.595.486A2.732 2.732 0 0 0 .863 3.218a2.724 2.724 0 0 0 2.363 2.695 19.557 19.557 0 0 1 2.92-3.65A2.725 2.725 0 0 0 3.595.486"
                    mask="url(#fM)"
                />
            </g>
            <g transform="translate(125 27)">
                <mask id="fP" fill="#fff">
                    <use xlink:href="#fN" />
                </mask>
                <path
                    fill="url(#fO)"
                    d="M3.22.016A3.19 3.19 0 0 0 .634 1.343a19.429 19.429 0 0 1 4.001 4.735 3.193 3.193 0 0 0 1.788-2.86A3.203 3.203 0 0 0 3.22.016"
                    mask="url(#fP)"
                />
            </g>
            <g transform="translate(131 26)">
                <mask id="fS" fill="#fff">
                    <use xlink:href="#fQ" />
                </mask>
                <path
                    fill="url(#fR)"
                    d="M6.971 3.915A3.234 3.234 0 0 0 4.048.992c-.101.009-.199.03-.303.03-.104 0-.202-.021-.303-.03A3.246 3.246 0 0 0 .488 4.218a3.257 3.257 0 0 0 3.257 3.257 3.244 3.244 0 0 0 3.226-2.954c-.009-.101-.03-.199-.03-.303 0-.104.021-.201.03-.303"
                    mask="url(#fS)"
                />
            </g>
            <g transform="translate(134 26)">
                <mask id="X" fill="#fff">
                    <use xlink:href="#aY" />
                </mask>
                <use xlink:href="#fT" mask="url(#X)" />
            </g>
            <g transform="translate(134 26)">
                <mask id="fV" fill="#fff">
                    <use xlink:href="#fU" />
                </mask>
                <use xlink:href="#fT" mask="url(#fV)" />
            </g>
            <g transform="translate(137 26)">
                <mask id="fY" fill="#fff">
                    <use xlink:href="#fW" />
                </mask>
                <path
                    fill="url(#fX)"
                    d="M4.573 7.517a3.317 3.317 0 0 0 2.928-2.528 3.628 3.628 0 0 1-.085-.771c0-.264.031-.522.085-.771A3.324 3.324 0 0 0 4.999.975a3.365 3.365 0 0 1-.729.084c-.251 0-.494-.032-.729-.084a3.316 3.316 0 0 0-2.57 2.94c.01.102.031.199.031.303 0 .104-.021.202-.031.303a3.308 3.308 0 0 0 2.996 2.996c.101-.01.199-.031.303-.031.104 0 .202.021.303.031"
                    mask="url(#fY)"
                />
            </g>
            <g transform="translate(140 26)">
                <mask id="Z" fill="#fff">
                    <use xlink:href="#aZ" />
                </mask>
                <use xlink:href="#fZ" mask="url(#Z)" />
            </g>
            <g transform="translate(140 26)">
                <mask id="gb" fill="#fff">
                    <use xlink:href="#ga" />
                </mask>
                <use xlink:href="#fZ" mask="url(#gb)" />
            </g>
            <g transform="translate(137 29)">
                <mask id="ab" fill="#fff">
                    <use xlink:href="#ba" />
                </mask>
                <use xlink:href="#gc" mask="url(#ab)" />
            </g>
            <g transform="translate(137 29)">
                <mask id="ge" fill="#fff">
                    <use xlink:href="#gd" />
                </mask>
                <use xlink:href="#gc" mask="url(#ge)" />
            </g>
            <g transform="translate(67 34)">
                <mask id="gh" fill="#fff">
                    <use xlink:href="#gf" />
                </mask>
                <path
                    fill="url(#gg)"
                    d="M2.495 4.842a2.1 2.1 0 1 0 0-4.199 2.1 2.1 0 0 0 0 4.199"
                    mask="url(#gh)"
                />
            </g>
            <g transform="translate(73 34)">
                <mask id="gk" fill="#fff">
                    <use xlink:href="#gi" />
                </mask>
                <path
                    fill="url(#gj)"
                    d="M3.02.536a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414"
                    mask="url(#gk)"
                />
            </g>
            <g transform="translate(80 34)">
                <mask id="gn" fill="#fff">
                    <use xlink:href="#gl" />
                </mask>
                <path
                    fill="url(#gm)"
                    d="M2.545.391a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704"
                    mask="url(#gn)"
                />
            </g>
            <g transform="translate(86 34)">
                <mask id="gq" fill="#fff">
                    <use xlink:href="#go" />
                </mask>
                <path
                    fill="url(#gp)"
                    d="M3.07.246a2.497 2.497 0 1 0 0 4.994 2.497 2.497 0 0 0 0-4.994"
                    mask="url(#gq)"
                />
            </g>
            <g transform="translate(92 34)">
                <mask id="gt" fill="#fff">
                    <use xlink:href="#gr" />
                </mask>
                <path
                    fill="url(#gs)"
                    d="M.454 2.743c0 .547.168 1.054.454 1.475.41-1.422.955-2.77 1.618-4.038A2.623 2.623 0 0 0 .454 2.743"
                    mask="url(#gt)"
                />
            </g>
            <g transform="translate(131 33)">
                <mask id="gw" fill="#fff">
                    <use xlink:href="#gu" />
                </mask>
                <path
                    fill="url(#gv)"
                    d="M3.745.54a3.203 3.203 0 1 0 .001 6.405A3.203 3.203 0 0 0 3.745.54"
                    mask="url(#gw)"
                />
            </g>
            <g transform="translate(138 33)">
                <mask id="gz" fill="#fff">
                    <use xlink:href="#gx" />
                </mask>
                <path
                    fill="url(#gy)"
                    d="M6.511 3.588A3.238 3.238 0 0 0 3.573.517c-.101.009-.199.03-.303.03-.104 0-.202-.021-.303-.03A3.246 3.246 0 0 0 .013 3.743 3.257 3.257 0 0 0 3.27 7a3.249 3.249 0 0 0 3.241-3.102c-.002-.052-.015-.102-.015-.155 0-.053.013-.102.015-.155"
                    mask="url(#gz)"
                />
            </g>
            <g transform="translate(140 33)">
                <mask id="ad" fill="#fff">
                    <use xlink:href="#bb" />
                </mask>
                <use xlink:href="#gA" mask="url(#ad)" />
            </g>
            <g transform="translate(140 33)">
                <mask id="gC" fill="#fff">
                    <use xlink:href="#gB" />
                </mask>
                <use xlink:href="#gA" mask="url(#gC)" />
            </g>
            <g transform="translate(67 41)">
                <mask id="gF" fill="#fff">
                    <use xlink:href="#gD" />
                </mask>
                <path
                    fill="url(#gE)"
                    d="M2.495.35a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837"
                    mask="url(#gF)"
                />
            </g>
            <g transform="translate(73 41)">
                <mask id="gI" fill="#fff">
                    <use xlink:href="#gG" />
                </mask>
                <path
                    fill="url(#gH)"
                    d="M3.02.169a2.1 2.1 0 1 0 0 4.199 2.1 2.1 0 0 0 0-4.199"
                    mask="url(#gI)"
                />
            </g>
            <g transform="translate(80 41)">
                <mask id="gL" fill="#fff">
                    <use xlink:href="#gJ" />
                </mask>
                <path
                    fill="url(#gK)"
                    d="M2.545.061a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414"
                    mask="url(#gL)"
                />
            </g>
            <g transform="translate(86 40)">
                <mask id="gO" fill="#fff">
                    <use xlink:href="#gM" />
                </mask>
                <path
                    fill="url(#gN)"
                    d="M3.07.916a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704"
                    mask="url(#gO)"
                />
            </g>
            <g transform="translate(132 40)">
                <mask id="gR" fill="#fff">
                    <use xlink:href="#gP" />
                </mask>
                <path
                    fill="url(#gQ)"
                    d="M2.745.156c-.891 0-1.689.379-2.256.979.191 1.243.306 2.518.306 3.83 0 .232-.023.456-.03.686.54.449 1.224.729 1.98.729a3.112 3.112 0 1 0 0-6.224"
                    mask="url(#gR)"
                />
            </g>
            <g transform="translate(138 40)">
                <mask id="gU" fill="#fff">
                    <use xlink:href="#gS" />
                </mask>
                <path
                    fill="url(#gT)"
                    d="M3.27.066a3.202 3.202 0 1 0 0 6.406 3.202 3.202 0 0 0 0-6.406"
                    mask="url(#gU)"
                />
            </g>
            <g transform="translate(67 48)">
                <mask id="gX" fill="#fff">
                    <use xlink:href="#gV" />
                </mask>
                <path
                    fill="url(#gW)"
                    d="M2.495.038a1.755 1.755 0 1 0 0 3.51 1.755 1.755 0 0 0 0-3.51"
                    mask="url(#gX)"
                />
            </g>
            <g transform="translate(74 47)">
                <mask id="ha" fill="#fff">
                    <use xlink:href="#gY" />
                </mask>
                <path
                    fill="url(#gZ)"
                    d="M2.02.875a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837"
                    mask="url(#ha)"
                />
            </g>
            <g transform="translate(80 47)">
                <mask id="hd" fill="#fff">
                    <use xlink:href="#hb" />
                </mask>
                <path
                    fill="url(#hc)"
                    d="M2.545.694a2.098 2.098 0 1 0 0 4.197 2.098 2.098 0 0 0 0-4.197"
                    mask="url(#hd)"
                />
            </g>
            <g transform="translate(86 47)">
                <mask id="hg" fill="#fff">
                    <use xlink:href="#he" />
                </mask>
                <path
                    fill="url(#hf)"
                    d="M3.07.586A2.207 2.207 0 1 0 3.07 5a2.207 2.207 0 0 0 0-4.414"
                    mask="url(#hg)"
                />
            </g>
            <g transform="translate(132 46)">
                <mask id="hj" fill="#fff">
                    <use xlink:href="#hh" />
                </mask>
                <path
                    fill="url(#hi)"
                    d="M2.745.753a3.02 3.02 0 0 0-2.101.851A24.004 24.004 0 0 1 .02 5.117a3.032 3.032 0 0 0 5.765-1.324 3.04 3.04 0 0 0-3.04-3.04"
                    mask="url(#hj)"
                />
            </g>
            <g transform="translate(138 46)">
                <mask id="hm" fill="#fff">
                    <use xlink:href="#hk" />
                </mask>
                <path
                    fill="url(#hl)"
                    d="M3.27.681a3.112 3.112 0 1 0 0 6.223 3.112 3.112 0 0 0 0-6.223"
                    mask="url(#hm)"
                />
            </g>
            <g transform="translate(67 54)">
                <mask id="hp" fill="#fff">
                    <use xlink:href="#hn" />
                </mask>
                <path
                    fill="url(#ho)"
                    d="M2.495.762a1.556 1.556 0 1 0 0 3.113 1.556 1.556 0 0 0 0-3.113"
                    mask="url(#hp)"
                />
            </g>
            <g transform="translate(74 54)">
                <mask id="hs" fill="#fff">
                    <use xlink:href="#hq" />
                </mask>
                <path
                    fill="url(#hr)"
                    d="M2.02.563a1.755 1.755 0 1 0 0 3.51 1.755 1.755 0 0 0 0-3.51"
                    mask="url(#hs)"
                />
            </g>
            <g transform="translate(80 54)">
                <mask id="hv" fill="#fff">
                    <use xlink:href="#ht" />
                </mask>
                <path
                    fill="url(#hu)"
                    d="M2.545.4a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837"
                    mask="url(#hv)"
                />
            </g>
            <g transform="translate(86 54)">
                <mask id="hy" fill="#fff">
                    <use xlink:href="#hw" />
                </mask>
                <path
                    fill="url(#hx)"
                    d="M3.07.219a2.1 2.1 0 1 0 0 4.199 2.1 2.1 0 0 0 0-4.199"
                    mask="url(#hy)"
                />
            </g>
            <g transform="translate(93 54)">
                <mask id="hB" fill="#fff">
                    <use xlink:href="#hz" />
                </mask>
                <path
                    fill="url(#hA)"
                    d="M2.595 4.525c.206 0 .402-.037.591-.09A20.449 20.449 0 0 1 1.034.758a2.206 2.206 0 0 0 1.561 3.767"
                    mask="url(#hB)"
                />
            </g>
            <g transform="translate(127 54)">
                <mask id="hE" fill="#fff">
                    <use xlink:href="#hC" />
                </mask>
                <path
                    fill="url(#hD)"
                    d="M1.22 5.177a2.859 2.859 0 0 0 2.859-2.859A2.83 2.83 0 0 0 3.675.876 20.168 20.168 0 0 1 .992 5.154c.077.006.15.023.228.023"
                    mask="url(#hE)"
                />
            </g>
            <g transform="translate(131 53)">
                <mask id="hH" fill="#fff">
                    <use xlink:href="#hF" />
                </mask>
                <path
                    fill="url(#hG)"
                    d="M3.745.369a2.949 2.949 0 1 0 0 5.899 2.95 2.95 0 0 0 0-5.899"
                    mask="url(#hH)"
                />
            </g>
            <g transform="translate(138 53)">
                <mask id="hK" fill="#fff">
                    <use xlink:href="#hI" />
                </mask>
                <path
                    fill="url(#hJ)"
                    d="M3.27.278a3.04 3.04 0 1 0 0 6.08 3.04 3.04 0 0 0 0-6.08"
                    mask="url(#hK)"
                />
            </g>
            <g transform="translate(68 61)">
                <mask id="hN" fill="#fff">
                    <use xlink:href="#hL" />
                </mask>
                <path
                    fill="url(#hM)"
                    d="M2.906 1.843A1.41 1.41 0 0 0 1.495.432a1.38 1.38 0 0 0-.622.16c.343.872.712 1.727 1.108 2.564a1.4 1.4 0 0 0 .925-1.313"
                    mask="url(#hN)"
                />
            </g>
            <g transform="translate(74 61)">
                <mask id="hQ" fill="#fff">
                    <use xlink:href="#hO" />
                </mask>
                <path
                    fill="url(#hP)"
                    d="M2.02.287a1.556 1.556 0 1 0 0 3.113 1.556 1.556 0 0 0 0-3.113"
                    mask="url(#hQ)"
                />
            </g>
            <g transform="translate(80 61)">
                <mask id="hT" fill="#fff">
                    <use xlink:href="#hR" />
                </mask>
                <path
                    fill="url(#hS)"
                    d="M2.545.088a1.755 1.755 0 1 0 0 3.51 1.755 1.755 0 0 0 0-3.51"
                    mask="url(#hT)"
                />
            </g>
            <g transform="translate(87 60)">
                <mask id="hW" fill="#fff">
                    <use xlink:href="#hU" />
                </mask>
                <path
                    fill="url(#hV)"
                    d="M2.07.925a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837"
                    mask="url(#hW)"
                />
            </g>
            <g transform="translate(93 60)">
                <mask id="hZ" fill="#fff">
                    <use xlink:href="#hX" />
                </mask>
                <path
                    fill="url(#hY)"
                    d="M2.595.744a2.1 2.1 0 1 0 0 4.199 2.1 2.1 0 0 0 0-4.199"
                    mask="url(#hZ)"
                />
            </g>
            <g transform="translate(99 62)">
                <mask id="ic" fill="#fff">
                    <use xlink:href="#ia" />
                </mask>
                <path
                    fill="url(#ib)"
                    d="M.913.843c0 1.22.988 2.208 2.207 2.208.586 0 1.115-.233 1.51-.605A18.863 18.863 0 0 1 .995.276C.947.458.913.646.913.843"
                    mask="url(#ic)"
                />
            </g>
            <g transform="translate(120 62)">
                <mask id="if" fill="#fff">
                    <use xlink:href="#id" />
                </mask>
                <path
                    fill="url(#ie)"
                    d="M1.695 3.467A2.624 2.624 0 0 0 4.319.843c0-.068-.015-.132-.02-.199-1.285.913-2.71 1.652-4.237 2.237a2.596 2.596 0 0 0 1.633.586"
                    mask="url(#if)"
                />
            </g>
            <g transform="translate(125 60)">
                <mask id="ii" fill="#fff">
                    <use xlink:href="#ig" />
                </mask>
                <path
                    fill="url(#ih)"
                    d="M3.22.111c-.553 0-1.065.167-1.495.449-.247.248-.491.499-.752.732A2.732 2.732 0 1 0 3.22.111"
                    mask="url(#ii)"
                />
            </g>
            <g transform="translate(131 59)">
                <mask id="il" fill="#fff">
                    <use xlink:href="#ij" />
                </mask>
                <path
                    fill="url(#ik)"
                    d="M3.745.984a2.859 2.859 0 1 0 0 5.718 2.859 2.859 0 0 0 0-5.718"
                    mask="url(#il)"
                />
            </g>
            <g transform="translate(138 59)">
                <mask id="io" fill="#fff">
                    <use xlink:href="#im" />
                </mask>
                <path
                    fill="url(#in)"
                    d="M3.27.894a2.949 2.949 0 1 0 0 5.897 2.949 2.949 0 0 0 0-5.897"
                    mask="url(#io)"
                />
            </g>
            <g transform="translate(74 67)">
                <mask id="ir" fill="#fff">
                    <use xlink:href="#ip" />
                </mask>
                <path
                    fill="url(#iq)"
                    d="M3.431 2.369a1.41 1.41 0 1 0-2.822-.002 1.41 1.41 0 0 0 2.822.002"
                    mask="url(#ir)"
                />
            </g>
            <g transform="translate(80 67)">
                <mask id="iu" fill="#fff">
                    <use xlink:href="#is" />
                </mask>
                <path
                    fill="url(#it)"
                    d="M2.545.812a1.557 1.557 0 1 0 .001 3.113A1.557 1.557 0 0 0 2.545.812"
                    mask="url(#iu)"
                />
            </g>
            <g transform="translate(87 67)">
                <mask id="ix" fill="#fff">
                    <use xlink:href="#iv" />
                </mask>
                <path
                    fill="url(#iw)"
                    d="M2.07.613a1.756 1.756 0 1 0 .001 3.511A1.756 1.756 0 0 0 2.07.613"
                    mask="url(#ix)"
                />
            </g>
            <g transform="translate(93 67)">
                <mask id="iA" fill="#fff">
                    <use xlink:href="#iy" />
                </mask>
                <path
                    fill="url(#iz)"
                    d="M2.595.45a1.919 1.919 0 1 0 .001 3.837A1.919 1.919 0 0 0 2.595.45"
                    mask="url(#iA)"
                />
            </g>
            <g transform="translate(100 67)">
                <mask id="iD" fill="#fff">
                    <use xlink:href="#iB" />
                </mask>
                <path
                    fill="url(#iC)"
                    d="M2.12.269a2.1 2.1 0 1 0 .001 4.2 2.1 2.1 0 0 0-.001-4.2"
                    mask="url(#iD)"
                />
            </g>
            <g transform="translate(106 67)">
                <mask id="iG" fill="#fff">
                    <use xlink:href="#iE" />
                </mask>
                <path
                    fill="url(#iF)"
                    d="M2.645.161a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414"
                    mask="url(#iG)"
                />
            </g>
            <g transform="translate(112 67)">
                <mask id="iJ" fill="#fff">
                    <use xlink:href="#iH" />
                </mask>
                <path
                    fill="url(#iI)"
                    d="M3.17.016a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704"
                    mask="url(#iJ)"
                />
            </g>
            <g transform="translate(119 66)">
                <mask id="iM" fill="#fff">
                    <use xlink:href="#iK" />
                </mask>
                <path
                    fill="url(#iL)"
                    d="M2.695.871a2.497 2.497 0 1 0 0 4.995 2.497 2.497 0 0 0 0-4.995"
                    mask="url(#iM)"
                />
            </g>
            <g transform="translate(125 66)">
                <mask id="iP" fill="#fff">
                    <use xlink:href="#iN" />
                </mask>
                <path
                    fill="url(#iO)"
                    d="M3.22.745a2.624 2.624 0 1 0 0 5.247 2.624 2.624 0 0 0 0-5.247"
                    mask="url(#iP)"
                />
            </g>
            <g transform="translate(132 66)">
                <mask id="iS" fill="#fff">
                    <use xlink:href="#iQ" />
                </mask>
                <path
                    fill="url(#iR)"
                    d="M2.745.636a2.732 2.732 0 1 0 0 5.464 2.732 2.732 0 0 0 0-5.464"
                    mask="url(#iS)"
                />
            </g>
            <g transform="translate(138 66)">
                <mask id="iV" fill="#fff">
                    <use xlink:href="#iT" />
                </mask>
                <path
                    fill="url(#iU)"
                    d="M3.27.509a2.86 2.86 0 1 0 0 5.718 2.86 2.86 0 0 0 0-5.718"
                    mask="url(#iV)"
                />
            </g>
            <g transform="translate(81 74)">
                <mask id="iY" fill="#fff">
                    <use xlink:href="#iW" />
                </mask>
                <path
                    fill="url(#iX)"
                    d="M1.545.482a1.411 1.411 0 1 0 0 2.823 1.411 1.411 0 0 0 0-2.823"
                    mask="url(#iY)"
                />
            </g>
            <g transform="translate(87 74)">
                <mask id="jb" fill="#fff">
                    <use xlink:href="#iZ" />
                </mask>
                <path
                    fill="url(#ja)"
                    d="M2.07.337a1.556 1.556 0 1 0 0 3.113 1.556 1.556 0 0 0 0-3.113"
                    mask="url(#jb)"
                />
            </g>
            <g transform="translate(93 74)">
                <mask id="je" fill="#fff">
                    <use xlink:href="#jc" />
                </mask>
                <path
                    fill="url(#jd)"
                    d="M2.595.138a1.755 1.755 0 1 0 0 3.51 1.755 1.755 0 0 0 0-3.51"
                    mask="url(#je)"
                />
            </g>
            <g transform="translate(100 73)">
                <mask id="jh" fill="#fff">
                    <use xlink:href="#jf" />
                </mask>
                <path
                    fill="url(#jg)"
                    d="M2.12.975a1.918 1.918 0 1 0 0 3.837 1.918 1.918 0 0 0 0-3.837"
                    mask="url(#jh)"
                />
            </g>
            <g transform="translate(106 73)">
                <mask id="jk" fill="#fff">
                    <use xlink:href="#ji" />
                </mask>
                <path
                    fill="url(#jj)"
                    d="M2.645.794a2.1 2.1 0 1 0 0 4.199 2.1 2.1 0 0 0 0-4.199"
                    mask="url(#jk)"
                />
            </g>
            <g transform="translate(112 73)">
                <mask id="jn" fill="#fff">
                    <use xlink:href="#jl" />
                </mask>
                <path
                    fill="url(#jm)"
                    d="M3.17.686a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414"
                    mask="url(#jn)"
                />
            </g>
            <g transform="translate(119 73)">
                <mask id="jq" fill="#fff">
                    <use xlink:href="#jo" />
                </mask>
                <path
                    fill="url(#jp)"
                    d="M2.695.54a2.353 2.353 0 1 0 .002 4.706A2.353 2.353 0 0 0 2.695.54"
                    mask="url(#jq)"
                />
            </g>
            <g transform="translate(125 73)">
                <mask id="jt" fill="#fff">
                    <use xlink:href="#jr" />
                </mask>
                <path
                    fill="url(#js)"
                    d="M3.22.396a2.497 2.497 0 1 0 0 4.994 2.497 2.497 0 0 0 0-4.994"
                    mask="url(#jt)"
                />
            </g>
            <g transform="translate(132 73)">
                <mask id="jw" fill="#fff">
                    <use xlink:href="#ju" />
                </mask>
                <path
                    fill="url(#jv)"
                    d="M2.745.27a2.623 2.623 0 1 0-.001 5.247A2.623 2.623 0 0 0 2.745.27"
                    mask="url(#jw)"
                />
            </g>
            <g transform="translate(138 73)">
                <mask id="jz" fill="#fff">
                    <use xlink:href="#jx" />
                </mask>
                <path
                    fill="url(#jy)"
                    d="M3.27.161a2.732 2.732 0 1 0 0 5.464 2.732 2.732 0 0 0 0-5.464"
                    mask="url(#jz)"
                />
            </g>
            <g transform="translate(87 81)">
                <mask id="jC" fill="#fff">
                    <use xlink:href="#jA" />
                </mask>
                <path
                    fill="url(#jB)"
                    d="M3.482 1.418a1.412 1.412 0 0 0-2.823 0c0 .176.041.341.1.497.535.294 1.08.576 1.629.85.621-.147 1.094-.681 1.094-1.347"
                    mask="url(#jC)"
                />
            </g>
            <g transform="translate(94 81)">
                <mask id="jF" fill="#fff">
                    <use xlink:href="#jD" />
                </mask>
                <path
                    fill="url(#jE)"
                    d="M1.595.069a1.556 1.556 0 1 0 0 3.112 1.556 1.556 0 0 0 0-3.112"
                    mask="url(#jF)"
                />
            </g>
            <g transform="translate(100 80)">
                <mask id="jI" fill="#fff">
                    <use xlink:href="#jG" />
                </mask>
                <path
                    fill="url(#jH)"
                    d="M2.12.871a1.754 1.754 0 1 0-.001 3.509A1.754 1.754 0 0 0 2.12.871"
                    mask="url(#jI)"
                />
            </g>
            <g transform="translate(106 80)">
                <mask id="jL" fill="#fff">
                    <use xlink:href="#jJ" />
                </mask>
                <path
                    fill="url(#jK)"
                    d="M2.645.708a1.918 1.918 0 1 0-.001 3.835A1.918 1.918 0 0 0 2.645.708"
                    mask="url(#jL)"
                />
            </g>
            <g transform="translate(113 80)">
                <mask id="jO" fill="#fff">
                    <use xlink:href="#jM" />
                </mask>
                <path
                    fill="url(#jN)"
                    d="M2.17.665a2.098 2.098 0 1 0-.001 4.197A2.098 2.098 0 0 0 2.17.665"
                    mask="url(#jO)"
                />
            </g>
            <g transform="translate(119 80)">
                <mask id="jR" fill="#fff">
                    <use xlink:href="#jP" />
                </mask>
                <path
                    fill="url(#jQ)"
                    d="M2.695.487a2.207 2.207 0 1 0 0 4.414 2.207 2.207 0 0 0 0-4.414"
                    mask="url(#jR)"
                />
            </g>
            <g transform="translate(125 80)">
                <mask id="jU" fill="#fff">
                    <use xlink:href="#jS" />
                </mask>
                <path
                    fill="url(#jT)"
                    d="M3.22.066a2.352 2.352 0 1 0 0 4.704 2.352 2.352 0 0 0 0-4.704"
                    mask="url(#jU)"
                />
            </g>
            <g transform="translate(132 79)">
                <mask id="jX" fill="#fff">
                    <use xlink:href="#jV" />
                </mask>
                <path
                    fill="url(#jW)"
                    d="M2.745.921A2.498 2.498 0 0 0 .248 3.418c0 .954.542 1.775 1.33 2.195a45.756 45.756 0 0 0 3.626-1.816c.019-.125.038-.249.038-.379A2.498 2.498 0 0 0 2.745.921"
                    mask="url(#jX)"
                />
            </g>
            <g transform="translate(138 79)">
                <mask id="ka" fill="#fff">
                    <use xlink:href="#jY" />
                </mask>
                <path
                    fill="url(#jZ)"
                    d="M.453 3.077A43.866 43.866 0 0 0 4.293.486 2.806 2.806 0 0 0 3.27.288 2.818 2.818 0 0 0 .453 3.077"
                    mask="url(#ka)"
                />
            </g>
            <g transform="translate(94 85)">
                <mask id="kd" fill="#fff">
                    <use xlink:href="#kb" />
                </mask>
                <path
                    fill="url(#kc)"
                    d="M1.526.53C1.129.53.773.696.517.959c.782.282 1.576.542 2.381.786C2.798 1.063 2.236.53 1.526.53"
                    mask="url(#kd)"
                />
            </g>
            <g transform="translate(100 86)">
                <mask id="kg" fill="#fff">
                    <use xlink:href="#ke" />
                </mask>
                <path
                    fill="url(#kf)"
                    d="M2.12.754c-.656 0-1.212.409-1.441.985.984.216 1.985.396 2.994.556A1.555 1.555 0 0 0 2.12.754"
                    mask="url(#kg)"
                />
            </g>
            <g transform="translate(106 87)">
                <mask id="kj" fill="#fff">
                    <use xlink:href="#kh" />
                </mask>
                <path
                    fill="url(#ki)"
                    d="M2.645.188c-.888 0-1.593.671-1.709 1.527 1.141.111 2.296.188 3.464.229v-.001C4.4.974 3.614.188 2.645.188"
                    mask="url(#kj)"
                />
            </g>
            <g transform="translate(113 87)">
                <mask id="km" fill="#fff">
                    <use xlink:href="#kk" />
                </mask>
                <path
                    fill="url(#kl)"
                    d="M2.17.163C1.15.163.324.962.264 1.967a56.41 56.41 0 0 0 3.795-.178A1.915 1.915 0 0 0 2.17.163"
                    mask="url(#km)"
                />
            </g>
            <g transform="translate(119 86)">
                <mask id="kp" fill="#fff">
                    <use xlink:href="#kn" />
                </mask>
                <path
                    fill="url(#ko)"
                    d="M2.695.844A2.1 2.1 0 0 0 .64 2.517a53.462 53.462 0 0 0 3.843-.659A2.09 2.09 0 0 0 2.695.844"
                    mask="url(#kp)"
                />
            </g>
            <g transform="translate(126 85)">
                <mask id="ks" fill="#fff">
                    <use xlink:href="#kq" />
                </mask>
                <path
                    fill="url(#kr)"
                    d="M.673 2.095A48.586 48.586 0 0 0 3.924 1.07 2.195 2.195 0 0 0 2.718.708C1.79.708.999 1.284.673 2.095"
                    mask="url(#ks)"
                />
            </g>
            <g transform="translate(144 13)">
                <mask id="kv" fill="#fff">
                    <use xlink:href="#kt" />
                </mask>
                <path
                    fill="url(#ku)"
                    d="M.497 5.194c.281.98.944 1.787 1.825 2.259a3.664 3.664 0 0 1 1.756-.462 3.66 3.66 0 0 1 1.756.462 3.725 3.725 0 0 0 1.218-1.037A41.35 41.35 0 0 0 2.294.898 3.725 3.725 0 0 0 .497 3.142c.103.326.175.666.175 1.026S.6 4.869.497 5.194"
                    mask="url(#kv)"
                />
            </g>
            <g transform="translate(144 16)">
                <mask id="af" fill="#fff">
                    <use xlink:href="#bc" />
                </mask>
                <use xlink:href="#kw" mask="url(#af)" />
            </g>
            <g transform="translate(144 16)">
                <mask id="ky" fill="#fff">
                    <use xlink:href="#kx" />
                </mask>
                <use xlink:href="#kw" mask="url(#ky)" />
            </g>
            <g transform="translate(144 20)">
                <mask id="kB" fill="#fff">
                    <use xlink:href="#kz" />
                </mask>
                <path
                    fill="url(#kA)"
                    d="M2.322.453A3.685 3.685 0 0 0 .499 2.795c.08.287.136.585.136.898 0 .314-.056.611-.136.899a3.693 3.693 0 0 0 1.906 2.387 3.621 3.621 0 0 1 1.673-.423c.606 0 1.17.162 1.673.423a3.694 3.694 0 0 0 1.822-2.115 3.703 3.703 0 0 1-.206-1.171c0-.411.083-.8.206-1.171A3.682 3.682 0 0 0 5.834.453 3.697 3.697 0 0 1 4.078.91 3.7 3.7 0 0 1 2.322.453"
                    mask="url(#kB)"
                />
            </g>
            <g transform="translate(144 22)">
                <mask id="ah" fill="#fff">
                    <use xlink:href="#bd" />
                </mask>
                <use xlink:href="#kC" mask="url(#ah)" />
            </g>
            <g transform="translate(144 22)">
                <mask id="kE" fill="#fff">
                    <use xlink:href="#kD" />
                </mask>
                <use xlink:href="#kC" mask="url(#kE)" />
            </g>
            <g transform="translate(146 19)">
                <mask id="aj" fill="#fff">
                    <use xlink:href="#be" />
                </mask>
                <use xlink:href="#kF" mask="url(#aj)" />
            </g>
            <g transform="translate(146 19)">
                <mask id="kH" fill="#fff">
                    <use xlink:href="#kG" />
                </mask>
                <use xlink:href="#kF" mask="url(#kH)" />
            </g>
            <g transform="translate(144 26)">
                <mask id="kK" fill="#fff">
                    <use xlink:href="#kI" />
                </mask>
                <path
                    fill="url(#kJ)"
                    d="M7.499 5.495a3.826 3.826 0 0 1-.236-1.277c0-.449.094-.874.236-1.276A3.648 3.648 0 0 0 5.751.979a3.666 3.666 0 0 1-1.673.416A3.672 3.672 0 0 1 2.405.979 3.648 3.648 0 0 0 .501 3.447c.059.249.098.505.098.771 0 .267-.039.523-.098.771a3.657 3.657 0 0 0 2.028 2.537 3.552 3.552 0 0 1 1.549-.365c.557 0 1.078.138 1.549.365a3.663 3.663 0 0 0 1.872-2.031"
                    mask="url(#kK)"
                />
            </g>
            <g transform="translate(144 29)">
                <mask id="al" fill="#fff">
                    <use xlink:href="#bf" />
                </mask>
                <use xlink:href="#kL" mask="url(#al)" />
            </g>
            <g transform="translate(144 29)">
                <mask id="kN" fill="#fff">
                    <use xlink:href="#kM" />
                </mask>
                <use xlink:href="#kL" mask="url(#kN)" />
            </g>
            <g transform="translate(146 26)">
                <mask id="an" fill="#fff">
                    <use xlink:href="#bg" />
                </mask>
                <use xlink:href="#kO" mask="url(#an)" />
            </g>
            <g transform="translate(146 26)">
                <mask id="kQ" fill="#fff">
                    <use xlink:href="#kP" />
                </mask>
                <use xlink:href="#kO" mask="url(#kQ)" />
            </g>
            <g transform="translate(144 33)">
                <mask id="kT" fill="#fff">
                    <use xlink:href="#kR" />
                </mask>
                <path
                    fill="url(#kS)"
                    d="M5.481 7.039a3.57 3.57 0 0 0 2.142-2.922c-.013-.124-.039-.246-.039-.374s.026-.249.039-.374A3.566 3.566 0 0 0 5.627.526 3.637 3.637 0 0 1 4.078.88 3.644 3.644 0 0 1 2.529.526 3.567 3.567 0 0 0 .511 3.588c.003.053.016.102.016.155 0 .053-.013.103-.016.155a3.577 3.577 0 0 0 2.164 3.141 3.51 3.51 0 0 1 2.806 0"
                    mask="url(#kT)"
                />
            </g>
            <g transform="translate(144 36)">
                <mask id="ap" fill="#fff">
                    <use xlink:href="#bh" />
                </mask>
                <use xlink:href="#kU" mask="url(#ap)" />
            </g>
            <g transform="translate(144 36)">
                <mask id="kW" fill="#fff">
                    <use xlink:href="#kV" />
                </mask>
                <use xlink:href="#kU" mask="url(#kW)" />
            </g>
            <g transform="translate(146 33)">
                <mask id="ar" fill="#fff">
                    <use xlink:href="#bi" />
                </mask>
                <use xlink:href="#kX" mask="url(#ar)" />
            </g>
            <g transform="translate(146 33)">
                <mask id="kZ" fill="#fff">
                    <use xlink:href="#kY" />
                </mask>
                <use xlink:href="#kX" mask="url(#kZ)" />
            </g>
            <g transform="translate(144 40)">
                <mask id="lc" fill="#fff">
                    <use xlink:href="#la" />
                </mask>
                <path
                    fill="url(#lb)"
                    d="M5.229 6.582a3.504 3.504 0 0 0 2.24-2.411 3.794 3.794 0 0 1-.119-.903c0-.312.048-.611.119-.902A3.517 3.517 0 0 0 5.481.039a3.565 3.565 0 0 1-2.806 0 3.522 3.522 0 0 0-2.12 3.229 3.51 3.51 0 0 0 2.372 3.314 3.406 3.406 0 0 1 1.151-.212c.406 0 .79.083 1.151.212"
                    mask="url(#lc)"
                />
            </g>
            <g transform="translate(146 39)">
                <mask id="at" fill="#fff">
                    <use xlink:href="#bj" />
                </mask>
                <use xlink:href="#ld" mask="url(#at)" />
            </g>
            <g transform="translate(146 39)">
                <mask id="lf" fill="#fff">
                    <use xlink:href="#le" />
                </mask>
                <use xlink:href="#ld" mask="url(#lf)" />
            </g>
            <g transform="translate(144 46)">
                <mask id="li" fill="#fff">
                    <use xlink:href="#lg" />
                </mask>
                <path
                    fill="url(#lh)"
                    d="M7.482 3.601A3.406 3.406 0 0 0 5.229.582a3.489 3.489 0 0 1-1.151.209c-.405 0-.788-.083-1.151-.209A3.416 3.416 0 0 0 .655 3.793a3.415 3.415 0 0 0 2.573 3.304c.273-.072.554-.122.85-.122.296 0 .577.05.85.122a3.408 3.408 0 0 0 2.554-3.112c-.003-.065-.02-.126-.02-.192s.017-.127.02-.192"
                    mask="url(#li)"
                />
            </g>
            <g transform="translate(146 46)">
                <mask id="av" fill="#fff">
                    <use xlink:href="#bk" />
                </mask>
                <use xlink:href="#lj" mask="url(#av)" />
            </g>
            <g transform="translate(146 46)">
                <mask id="ll" fill="#fff">
                    <use xlink:href="#lk" />
                </mask>
                <use xlink:href="#lj" mask="url(#ll)" />
            </g>
            <g transform="translate(144 53)">
                <mask id="lo" fill="#fff">
                    <use xlink:href="#lm" />
                </mask>
                <path
                    fill="url(#ln)"
                    d="M3.228.097A3.335 3.335 0 0 0 .735 3.318 3.331 3.331 0 0 0 3.766 6.63c.104-.009.205-.031.312-.031.107 0 .208.022.312.031a3.332 3.332 0 0 0 3.032-3.312A3.335 3.335 0 0 0 4.928.097c-.273.07-.555.119-.85.119-.295 0-.577-.049-.85-.119"
                    mask="url(#lo)"
                />
            </g>
            <g transform="translate(147 52)">
                <mask id="ax" fill="#fff">
                    <use xlink:href="#bl" />
                </mask>
                <use xlink:href="#lp" mask="url(#ax)" />
            </g>
            <g transform="translate(147 52)">
                <mask id="lr" fill="#fff">
                    <use xlink:href="#lq" />
                </mask>
                <use xlink:href="#lp" mask="url(#lr)" />
            </g>
            <g transform="translate(144 59)">
                <mask id="lu" fill="#fff">
                    <use xlink:href="#ls" />
                </mask>
                <path
                    fill="url(#lt)"
                    d="M3.766.63A3.233 3.233 0 0 0 .834 3.843a3.244 3.244 0 1 0 6.488 0A3.233 3.233 0 0 0 4.39.63c-.104.01-.205.032-.312.032-.107 0-.208-.022-.312-.032"
                    mask="url(#lu)"
                />
            </g>
            <g transform="translate(147 59)">
                <mask id="az" fill="#fff">
                    <use xlink:href="#bm" />
                </mask>
                <use xlink:href="#lv" mask="url(#az)" />
            </g>
            <g transform="translate(147 59)">
                <mask id="lx" fill="#fff">
                    <use xlink:href="#lw" />
                </mask>
                <use xlink:href="#lv" mask="url(#lx)" />
            </g>
            <g transform="translate(145 66)">
                <mask id="lA" fill="#fff">
                    <use xlink:href="#ly" />
                </mask>
                <path
                    fill="url(#lz)"
                    d="M3.078.426a2.942 2.942 0 1 0 0 5.884 2.942 2.942 0 0 0 0-5.884"
                    mask="url(#lA)"
                />
            </g>
            <g transform="translate(145 72)">
                <mask id="lD" fill="#fff">
                    <use xlink:href="#lB" />
                </mask>
                <path
                    fill="url(#lC)"
                    d="M.073 3.893a3 3 0 0 0 .214 1.099 41.589 41.589 0 0 0 3.769-3.927 2.938 2.938 0 0 0-.978-.177A3.005 3.005 0 0 0 .073 3.893"
                    mask="url(#lD)"
                />
            </g>
            <g transform="translate(151 21)">
                <mask id="lG" fill="#fff">
                    <use xlink:href="#lE" />
                </mask>
                <path
                    fill="url(#lF)"
                    d="M.573 3.864a3.87 3.87 0 0 0 1.555 2.035 4.116 4.116 0 0 1 1.89-.609A41.268 41.268 0 0 0 1.291.246a3.785 3.785 0 0 0-.718 1.276c.124.37.207.759.207 1.171 0 .412-.083.801-.207 1.171"
                    mask="url(#lG)"
                />
            </g>
            <g transform="translate(151 22)">
                <mask id="lI" fill="#fff">
                    <use xlink:href="#bn" />
                </mask>
                <path
                    fill="url(#lH)"
                    d="M.573 2.864c.124-.37.207-.759.207-1.171C.78 1.281.697.892.573.522.45.893.367 1.282.367 1.693c0 .411.083.8.206 1.171"
                    mask="url(#lI)"
                />
            </g>
            <g transform="translate(151 22)">
                <mask id="lL" fill="#fff">
                    <use xlink:href="#lJ" />
                </mask>
                <path
                    fill="url(#lK)"
                    d="M.573 2.864c.124-.37.207-.759.207-1.171C.78 1.281.697.892.573.522.45.893.367 1.282.367 1.693c0 .411.083.8.206 1.171"
                    mask="url(#lL)"
                />
            </g>
            <g transform="translate(151 26)">
                <mask id="lO" fill="#fff">
                    <use xlink:href="#lM" />
                </mask>
                <path
                    fill="url(#lN)"
                    d="M2.128.899A3.965 3.965 0 0 0 .499 2.942c.149.398.241.826.241 1.276 0 .451-.092.878-.241 1.277.326.926.99 1.689 1.856 2.163a3.795 3.795 0 0 1 1.981-.562c.583 0 1.128.14 1.62.371a3.832 3.832 0 0 1-.204-1.178c0-.368.069-.718.166-1.057A42.2 42.2 0 0 0 4.563 1.53c-.077.004-.149.022-.227.022A4.029 4.029 0 0 1 2.128.899"
                    mask="url(#lO)"
                />
            </g>
            <g transform="translate(151 28)">
                <mask id="lQ" fill="#fff">
                    <use xlink:href="#bo" />
                </mask>
                <path
                    fill="url(#lP)"
                    d="M.499 3.495c.149-.399.241-.826.241-1.277 0-.45-.092-.878-.241-1.276a3.815 3.815 0 0 0-.236 1.276c0 .449.094.874.236 1.277"
                    mask="url(#lQ)"
                />
            </g>
            <g transform="translate(151 28)">
                <mask id="lT" fill="#fff">
                    <use xlink:href="#lR" />
                </mask>
                <path
                    fill="url(#lS)"
                    d="M.499 3.495c.149-.399.241-.826.241-1.277 0-.45-.092-.878-.241-1.276a3.815 3.815 0 0 0-.236 1.276c0 .449.094.874.236 1.277"
                    mask="url(#lT)"
                />
            </g>
            <g transform="translate(153 26)">
                <mask id="lV" fill="#fff">
                    <use xlink:href="#bp" />
                </mask>
                <path
                    fill="url(#lU)"
                    d="M2.336 1.552c.078 0 .15-.018.227-.022-.175-.418-.358-.83-.545-1.24a4.116 4.116 0 0 0-1.89.609 4.029 4.029 0 0 0 2.208.653"
                    mask="url(#lV)"
                />
            </g>
            <g transform="translate(153 26)">
                <mask id="lY" fill="#fff">
                    <use xlink:href="#lW" />
                </mask>
                <path
                    fill="url(#lX)"
                    d="M2.336 1.552c.078 0 .15-.018.227-.022-.175-.418-.358-.83-.545-1.24a4.116 4.116 0 0 0-1.89.609 4.029 4.029 0 0 0 2.208.653"
                    mask="url(#lY)"
                />
            </g>
            <g transform="translate(156 33)">
                <mask id="mb" fill="#fff">
                    <use xlink:href="#lZ" />
                </mask>
                <path
                    fill="url(#ma)"
                    d="M1.644.887c-.029-.119-.052-.24-.082-.358-.077.049-.164.084-.244.129.114.069.22.148.326.229"
                    mask="url(#mb)"
                />
            </g>
            <g transform="translate(156 31)">
                <mask id="md" fill="#fff">
                    <use xlink:href="#bq" />
                </mask>
                <path
                    fill="url(#mc)"
                    d="M.956 2.467c.124.058.245.12.362.191.08-.045.167-.08.244-.129A43.625 43.625 0 0 0 .918.232a3.822 3.822 0 0 0-.166 1.057c0 .414.084.804.204 1.178"
                    mask="url(#md)"
                />
            </g>
            <g transform="translate(156 31)">
                <mask id="mg" fill="#fff">
                    <use xlink:href="#me" />
                </mask>
                <path
                    fill="url(#mf)"
                    d="M.956 2.467c.124.058.245.12.362.191.08-.045.167-.08.244-.129A43.625 43.625 0 0 0 .918.232a3.822 3.822 0 0 0-.166 1.057c0 .414.084.804.204 1.178"
                    mask="url(#mg)"
                />
            </g>
            <g transform="translate(151 33)">
                <mask id="mj" fill="#fff">
                    <use xlink:href="#mh" />
                </mask>
                <path
                    fill="url(#mi)"
                    d="M4.336 1.178a4.122 4.122 0 0 1-1.981-.52A3.616 3.616 0 0 0 .623 3.369c.013.125.038.246.038.374s-.025.25-.038.374a3.615 3.615 0 0 0 1.823 2.759 4.03 4.03 0 0 1 1.89-.483c.689 0 1.326.185 1.891.483a3.686 3.686 0 0 0 1.301-1.238 45.391 45.391 0 0 0-.618-3.59c-.36-.36-.65-.783-.85-1.255a4.13 4.13 0 0 1-1.724.385"
                    mask="url(#mj)"
                />
            </g>
            <g transform="translate(151 36)">
                <mask id="ml" fill="#fff">
                    <use xlink:href="#br" />
                </mask>
                <path
                    fill="url(#mk)"
                    d="M.623.369C.61.494.584.615.584.743s.026.25.039.374C.636.993.661.871.661.743S.636.494.623.369"
                    mask="url(#ml)"
                />
            </g>
            <g transform="translate(151 36)">
                <mask id="mo" fill="#fff">
                    <use xlink:href="#mm" />
                </mask>
                <path
                    fill="url(#mn)"
                    d="M.623.369C.61.494.584.615.584.743s.026.25.039.374C.636.993.661.871.661.743S.636.494.623.369"
                    mask="url(#mo)"
                />
            </g>
            <g transform="translate(153 33)">
                <mask id="mq" fill="#fff">
                    <use xlink:href="#bs" />
                </mask>
                <path
                    fill="url(#mp)"
                    d="M4.06.793C4.016.689 3.991.576 3.956.467a3.795 3.795 0 0 0-1.62-.371C1.607.096.931.307.355.658c.589.321 1.258.52 1.981.52A4.13 4.13 0 0 0 4.06.793"
                    mask="url(#mq)"
                />
            </g>
            <g transform="translate(153 33)">
                <mask id="mt" fill="#fff">
                    <use xlink:href="#mr" />
                </mask>
                <path
                    fill="url(#ms)"
                    d="M4.06.793C4.016.689 3.991.576 3.956.467a3.795 3.795 0 0 0-1.62-.371C1.607.096.931.307.355.658c.589.321 1.258.52 1.981.52A4.13 4.13 0 0 0 4.06.793"
                    mask="url(#mt)"
                />
            </g>
            <g transform="translate(156 33)">
                <mask id="mv" fill="#fff">
                    <use xlink:href="#bt" />
                </mask>
                <path
                    fill="url(#mu)"
                    d="M1.06.793c.2.472.49.895.85 1.255-.084-.39-.172-.777-.266-1.161a3.672 3.672 0 0 0-.326-.229c-.085.046-.169.094-.258.135"
                    mask="url(#mv)"
                />
            </g>
            <g transform="translate(156 33)">
                <mask id="my" fill="#fff">
                    <use xlink:href="#mw" />
                </mask>
                <path
                    fill="url(#mx)"
                    d="M1.06.793c.2.472.49.895.85 1.255-.084-.39-.172-.777-.266-1.161a3.672 3.672 0 0 0-.326-.229c-.085.046-.169.094-.258.135"
                    mask="url(#my)"
                />
            </g>
            <g transform="translate(156 33)">
                <mask id="mA" fill="#fff">
                    <use xlink:href="#bu" />
                </mask>
                <path
                    fill="url(#mz)"
                    d="M1.318.658A3.785 3.785 0 0 0 .956.467c.035.109.06.222.104.326.089-.041.173-.089.258-.135"
                    mask="url(#mA)"
                />
            </g>
            <g transform="translate(156 33)">
                <mask id="mD" fill="#fff">
                    <use xlink:href="#mB" />
                </mask>
                <path
                    fill="url(#mC)"
                    d="M1.318.658A3.785 3.785 0 0 0 .956.467c.035.109.06.222.104.326.089-.041.173-.089.258-.135"
                    mask="url(#mD)"
                />
            </g>
            <g transform="translate(156 33)">
                <mask id="mG" fill="#fff">
                    <use xlink:href="#mE" />
                </mask>
                <path
                    fill="url(#mF)"
                    d="M1.318.658A3.785 3.785 0 0 0 .956.467c.035.109.06.222.104.326.089-.041.173-.089.258-.135"
                    mask="url(#mG)"
                />
            </g>
            <g transform="translate(151 39)">
                <mask id="mJ" fill="#fff">
                    <use xlink:href="#mH" />
                </mask>
                <path
                    fill="url(#mI)"
                    d="M2.446.876c-.979.517-1.71 1.41-1.977 2.49.078.289.132.588.132.902 0 .314-.054.613-.132.903a3.877 3.877 0 0 0 1.849 2.422 3.92 3.92 0 0 1 2.018-.565 3.92 3.92 0 0 1 2.018.565 3.906 3.906 0 0 0 1.595-1.709 49.255 49.255 0 0 0-.14-3.484A3.935 3.935 0 0 0 6.227.876a3.79 3.79 0 0 1-1.891.514 3.783 3.783 0 0 1-1.89-.514"
                    mask="url(#mJ)"
                />
            </g>
            <g transform="translate(150 42)">
                <mask id="mL" fill="#fff">
                    <use xlink:href="#bv" />
                </mask>
                <path
                    fill="url(#mK)"
                    d="M1.469.366c-.071.291-.119.59-.119.902 0 .312.048.612.119.903.078-.29.132-.589.132-.903 0-.314-.054-.613-.132-.902"
                    mask="url(#mL)"
                />
            </g>
            <g transform="translate(150 42)">
                <mask id="mO" fill="#fff">
                    <use xlink:href="#mM" />
                </mask>
                <path
                    fill="url(#mN)"
                    d="M1.469.366c-.071.291-.119.59-.119.902 0 .312.048.612.119.903.078-.29.132-.589.132-.903 0-.314-.054-.613-.132-.902"
                    mask="url(#mO)"
                />
            </g>
            <g transform="translate(153 39)">
                <mask id="mQ" fill="#fff">
                    <use xlink:href="#bw" />
                </mask>
                <path
                    fill="url(#mP)"
                    d="M.446.876a3.783 3.783 0 0 0 1.89.514A3.79 3.79 0 0 0 4.227.876 4.034 4.034 0 0 0 2.336.393a4.03 4.03 0 0 0-1.89.483"
                    mask="url(#mQ)"
                />
            </g>
            <g transform="translate(153 39)">
                <mask id="mT" fill="#fff">
                    <use xlink:href="#mR" />
                </mask>
                <path
                    fill="url(#mS)"
                    d="M.446.876a3.783 3.783 0 0 0 1.89.514A3.79 3.79 0 0 0 4.227.876 4.034 4.034 0 0 0 2.336.393a4.03 4.03 0 0 0-1.89.483"
                    mask="url(#mT)"
                />
            </g>
            <g transform="translate(151 46)">
                <mask id="mW" fill="#fff">
                    <use xlink:href="#mU" />
                </mask>
                <path
                    fill="url(#mV)"
                    d="M6.143 7.105a3.83 3.83 0 0 0 1.293-1.074c.186-1.253.312-2.535.397-3.834A3.796 3.796 0 0 0 6.354.593a4.037 4.037 0 0 1-2.018.55c-.74 0-1.424-.209-2.018-.55A3.73 3.73 0 0 0 .482 3.601c.004.065.02.126.02.192s-.016.127-.02.192c.072 1.359.879 2.516 2.047 3.12a3.832 3.832 0 0 1 1.807-.465 3.83 3.83 0 0 1 1.807.465"
                    mask="url(#mW)"
                />
            </g>
            <g transform="translate(150 49)">
                <mask id="mY" fill="#fff">
                    <use xlink:href="#bx" />
                </mask>
                <path
                    fill="url(#mX)"
                    d="M1.482.601c-.003.065-.02.126-.02.192s.017.127.02.192c.004-.065.02-.126.02-.192s-.016-.127-.02-.192"
                    mask="url(#mY)"
                />
            </g>
            <g transform="translate(150 49)">
                <mask id="nb" fill="#fff">
                    <use xlink:href="#mZ" />
                </mask>
                <path
                    fill="url(#na)"
                    d="M1.482.601c-.003.065-.02.126-.02.192s.017.127.02.192c.004-.065.02-.126.02-.192s-.016-.127-.02-.192"
                    mask="url(#nb)"
                />
            </g>
            <g transform="translate(153 46)">
                <mask id="nd" fill="#fff">
                    <use xlink:href="#by" />
                </mask>
                <path
                    fill="url(#nc)"
                    d="M.318.593c.594.341 1.278.55 2.018.55.74 0 1.424-.209 2.018-.55A3.92 3.92 0 0 0 2.336.028 3.92 3.92 0 0 0 .318.593"
                    mask="url(#nd)"
                />
            </g>
            <g transform="translate(153 46)">
                <mask id="ng" fill="#fff">
                    <use xlink:href="#ne" />
                </mask>
                <path
                    fill="url(#nf)"
                    d="M.318.593c.594.341 1.278.55 2.018.55.74 0 1.424-.209 2.018-.55A3.92 3.92 0 0 0 2.336.028 3.92 3.92 0 0 0 .318.593"
                    mask="url(#ng)"
                />
            </g>
            <g transform="translate(151 53)">
                <mask id="nj" fill="#fff">
                    <use xlink:href="#nh" />
                </mask>
                <path
                    fill="url(#ni)"
                    d="M5.64 6.517A43.461 43.461 0 0 0 7.12.845a3.766 3.766 0 0 0-.977-.74 3.92 3.92 0 0 1-1.807.454A3.92 3.92 0 0 1 2.529.105C1.357.73.552 1.927.552 3.318c0 1.475.899 2.739 2.189 3.325a3.715 3.715 0 0 1 1.595-.369c.461 0 .898.093 1.304.243"
                    mask="url(#nj)"
                />
            </g>
            <g transform="translate(153 52)">
                <mask id="nl" fill="#fff">
                    <use xlink:href="#bz" />
                </mask>
                <path
                    fill="url(#nk)"
                    d="M4.143 1.105A3.83 3.83 0 0 0 2.336.64c-.658 0-1.267.178-1.807.465a3.92 3.92 0 0 0 1.807.454 3.92 3.92 0 0 0 1.807-.454"
                    mask="url(#nl)"
                />
            </g>
            <g transform="translate(153 52)">
                <mask id="no" fill="#fff">
                    <use xlink:href="#nm" />
                </mask>
                <path
                    fill="url(#nn)"
                    d="M4.143 1.105A3.83 3.83 0 0 0 2.336.64c-.658 0-1.267.178-1.807.465a3.92 3.92 0 0 0 1.807.454 3.92 3.92 0 0 0 1.807-.454"
                    mask="url(#no)"
                />
            </g>
            <g transform="translate(151 59)">
                <mask id="nr" fill="#fff">
                    <use xlink:href="#np" />
                </mask>
                <path
                    fill="url(#nq)"
                    d="M4.336.996A3.839 3.839 0 0 1 2.741.643C1.516 1.221.665 2.431.665 3.843c0 1.439.881 2.671 2.142 3.236A41.578 41.578 0 0 0 5.549.786c-.383.127-.786.21-1.213.21"
                    mask="url(#nr)"
                />
            </g>
            <g transform="translate(153 59)">
                <mask id="nt" fill="#fff">
                    <use xlink:href="#bA" />
                </mask>
                <path
                    fill="url(#ns)"
                    d="M3.549.786c.03-.09.062-.179.091-.269A3.752 3.752 0 0 0 2.336.274c-.574 0-1.111.14-1.595.369a3.839 3.839 0 0 0 1.595.353c.427 0 .83-.083 1.213-.21"
                    mask="url(#nt)"
                />
            </g>
            <g transform="translate(153 59)">
                <mask id="nw" fill="#fff">
                    <use xlink:href="#nu" />
                </mask>
                <path
                    fill="url(#nv)"
                    d="M3.549.786c.03-.09.062-.179.091-.269A3.752 3.752 0 0 0 2.336.274c-.574 0-1.111.14-1.595.369a3.839 3.839 0 0 0 1.595.353c.427 0 .83-.083 1.213-.21"
                    mask="url(#nw)"
                />
            </g>
            <g transform="translate(151 66)">
                <mask id="nz" fill="#fff">
                    <use xlink:href="#nx" />
                </mask>
                <path
                    fill="url(#ny)"
                    d="M.484 3.524c0 .107.023.208.033.312A41.164 41.164 0 0 0 2.674.332C1.388.853.484 2.085.484 3.524"
                    mask="url(#nz)"
                />
            </g>
        </g>
    </svg>
</template>
